import {
  Box,
  Center,
  Circle,
  Divider,
  Flex,
  Image,
  ListItem,
  SimpleGrid,
  Spacer,
  Icon,
  Stack,
  Link,
  Text,
  UnorderedList,
  VStack,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import PrimaryButton from "../../primary-button";
import { actionAccessMain, calculateEDD, formatDate_DD_MM_YYYY, formatDate_Do_MMM_YYYY, formatDate_YYYY_MM_DD, getLoginID } from "../../../auth";
import GrayCard from "./gray-header-card";
import { GetPatientHealthData } from "../../../middleware/services/visits/patient-overview";
import DynamicModal from "../../dynamic-modal";
import { COLORS } from "../../styles/colors";
import { ImEnlarge2 } from "react-icons/im";
import {
  GetDoctorNotes,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";
import ModalRight from "../../modal-right";
import useLoader from "../../loader/loaderstates";
import Loader from "../../loader/loader";
import { constructNow } from "date-fns";
import { addQuestions } from "../../../middleware/services/home/mentalhealthscreen";
import Toaster from "../../toaster";
import { options } from "@fullcalendar/core/preact.js";
import PrimaryInput from "../../primary-input";
import DatePicker from "../../date-picker";
import DatePickerEDD from "../../date-picker-EDD";

const StartVisitOverview = ({
  patientId,
  appointmentId,
  doctorId,
  patienData,
  displayOverview = false,
  onAddMedicalConditionClick,
  onAddMedicationClick,
  onAddSurgeryClick,
  onAddAllergyClick,
  onAddVaccineClick,
  onAddSocialHistoryClick,
  onHeaderClickChangeToTab,
}) => {
  const [patientVisitFormSection2, setPatientVisitFormSection2] =
    useState(null);
  const [patientVisitFormSection3, setPatientVisitFormSection3] =
    useState(null);
  const [patientVisitFormSection4, setPatientVisitFormSection4] =
    useState(null);
  const [patientVisitFormSection5, setPatientVisitFormSection5] =
    useState(null);
  const [patientVisitFormSection6, setPatientVisitFormSection6] =
    useState(null);

  const [inputData, setInputData] = useState({
    patientid: patientId,
    appointmentid: appointmentId,
    doctorid: doctorId,
    type: "advancevisit",
  });

  const visitFormSection2 = useRef();
  const visitFormSection3 = useRef();
  const visitFormSection4 = useRef();
  const visitFormSection5 = useRef();
  const visitFormSection6 = useRef();
  const LabResultsModalRef = useRef();
  const ImagingResultsModalRef = useRef();
  const [labsData, setLabsData] = useState([]);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const {showSuccessToast , showErrorToast} = Toaster();


   // Function to fetch patient entire health data and update state - FOR PATIENT CURRENT VISIT
   const fetchPatientHealthData = async () => {
    try {
      const data = await GetPatientHealthData(inputData);
      // console.log(data);
      // console.log('sectionFour PageLoad: ', data?.visitformdata?.section_four);
      setPatientVisitFormSection2(data?.visitformdata?.section_two);
      setPatientVisitFormSection3(data?.visitformdata?.section_three);
      setPatientVisitFormSection4(data?.visitformdata?.section_four);
      setPatientVisitFormSection5(data?.visitformdata?.section_five);
      setPatientVisitFormSection6(data?.visitformdata?.section_six);
    } catch (error) {
      console.error("Error fetching patient health data:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchPatientHealthData();
  }, []);
  const moreDetails = [
    {
      Heading: "Cardiology",
      Question: "What is the patient's blood pressure?",
      Answer: "120/80 mmHg",
    },
    {
      Heading: "Cardiology",
      Question: "Does the patient have a history of heart disease?",
      Answer: "No",
    },
    {
      Heading: "Neurology",
      Question: "Has the patient experienced headaches recently?",
      Answer: "Yes, mild headaches in the last week.",
    },
    {
      Heading: "Neurology",
      Question: "Any history of seizures?",
      Answer: "No history of seizures.",
    },
    {
      Heading: "Orthopedics",
      Question: "Is there any joint pain reported?",
      Answer: "Yes, occasional knee pain.",
    },
    {
      Heading: "Orthopedics",
      Question: "Has the patient undergone any surgeries?",
      Answer: "Yes, knee arthroscopy two years ago.",
    },
  ];
//console.log('patienData', patienData)
  //-----------------------------
  const [actionAccessPatients, setActionAccessPatients] = useState(null);
  useEffect(() => {
    setActionAccessPatients(actionAccessMain(4));
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

  const consumptionYears = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Calculating difference in ms
    const diffInMs = endDate - startDate;

    // Milliseconds to years
    const msInYear = 1000 * 60 * 60 * 24 * 365.25;
    const diffInYears = diffInMs / msInYear;

    if (diffInYears === 0) {
      return "Less than a year";
    }

    return diffInYears.toFixed(0) + " years";
  };

  const calculateYearsDifference = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Calculating difference in ms
    const diffInMs = endDate - startDate;

    // Milliseconds to years
    const msInYear = 1000 * 60 * 60 * 24 * 365.25;
    const diffInYears = diffInMs / msInYear;

    // if (diffInYears === 0) {
    //   return "Less than a year";
    // }

    return diffInYears.toFixed(0);
  };
  const formatDate_yyyy = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("yyyy");
  };
  const [Labresults, setLabresults] = useState(null);
  const [LabName, setLabName] = useState(null);
  const OpenLabResultModal = async (item) => {
    setLabresults(item.labresults)
    setLabName(item.name)
    LabResultsModalRef.current.openRight();
  };
  const [ImagingNormalValue, setImagingNormalValue] = useState(null);
  const [ImagingAbNormalValue, setImagingAbNormalValue] = useState(null);
  const [ImagingReportInterpretation, SetImagingReportInterpretation] = useState(null);
  const [ImagingName, setImagingName] = useState(null);
  const OpenImagingResultModal = async (item) => {
    setImagingName(item.name)
    setImagingNormalValue(item.normal);
    setImagingAbNormalValue(item.abnormal);
    SetImagingReportInterpretation(item.interpretation);
    ImagingResultsModalRef.current.openRight();
  };
  // ---------------Mental Screening Editable starts ------------------------------------------
  const [answers, setAnswers] = useState({});   

  const arrayToBind = [
    {
      title: 'Lifestyle Habits',
      questions: [
        { 
          id: 1, 
          text: 'Do you follow a balanced diet?', 
          options: ['Yes', 'No'], 
          defaultOption:'Yes',
          answer: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["1"]) 
          ? null 
          : (answers["Lifestyle Habits"]["1"]),
        },
        {
          id: 2,
          text: 'Do you consume at least 5 servings of fruits and vegetables daily?',
          options: ['Yes', 'No'],
          defaultOption:'Yes',
          answer: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["2"]) 
          ? null 
          : (answers["Lifestyle Habits"]["2"]),
        },
        {
          id: 3,
          text: 'How often do you consume fast food or processed food?',
          options: ['Frequently', 'Sometimes', 'Rarely', 'Never'],
          defaultOption:'Sometimes',
          answer: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["3"]) 
          ? null 
          : (answers["Lifestyle Habits"]["3"]),
        },
        {
          id: 4,
          text: 'How much water do you drink daily?',
          options: ['Less than 1 ltr', '1-2 ltrs', 'More than 2 ltrs'],
          defaultOption:'1-2 ltrs',
          answer: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["4"]) 
          ? null 
          : (answers["Lifestyle Habits"]["4"]),
        },
        {
          id: 5,
          text: 'Do you engage in regular physical activity (at least 30 minutes a day)?',
          options: ['Yes', 'No'],
          defaultOption:'Yes',
          answer: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["5"]) 
          ? null 
          : (answers["Lifestyle Habits"]["5"]),
          followUp: "If yes, specify the type and frequency",
          DefaultFollowup: (!answers || !answers["Lifestyle Habits"] || !answers["Lifestyle Habits"]["5"]) 
          ? "30 minutes" 
          : null 
        },
      ],
    },

    {
      title: 'Mental Health and Well-being',
      questions: [
        {
          id: 6,
          text: 'In the past month, have you felt low, down, or hopeless?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Mental Health and Well-being"] || !answers["Mental Health and Well-being"]["6"]) 
          ? null 
          : (answers["Mental Health and Well-being"]["6"]),
        },
        {
          id: 7,
          text: 'In the past month, have you experienced anxiety, excessive worry, or panic attacks?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Mental Health and Well-being"] || !answers["Mental Health and Well-being"]["7"]) 
          ? null 
          : (answers["Mental Health and Well-being"]["7"]),
        },
        {
          id: 8,
          text: 'Have you ever been diagnosed with any mental health conditions (e.g., depression, anxiety, bipolar disorder)?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Mental Health and Well-being"] || !answers["Mental Health and Well-being"]["8"]) 
          ? null 
          : (answers["Mental Health and Well-being"]["8"]),
          followUp: "If yes, please specify",
        },
        {
          id: 9,
          text: 'Are you currently undergoing any mental health treatments (e.g., therapy, medications)?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Mental Health and Well-being"] || !answers["Mental Health and Well-being"]["9"]) 
          ? null 
          : (answers["Mental Health and Well-being"]["9"]),
          followUp: "If yes, specify",
        },
      ],
    },

    {
      title: 'Sleep Patterns',
      questions: [
        {
          id: 10,
          text: 'How many hours of sleep do you get per night on average?',
          options: ['Less than 4 hours', '4-6 hours', '6-8 hours', 'More than 8 hours'],
          // answer: answers["Sleep Patterns"]["10"]
          defaultOption:'6-8 hours',
          answer: (!answers || !answers["Sleep Patterns"] || !answers["Sleep Patterns"]["10"]) 
          ? null 
          : (answers["Sleep Patterns"]["10"])
        },
        {
          id: 11,
          text: 'Do you have trouble falling asleep or staying asleep?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Sleep Patterns"] || !answers["Sleep Patterns"]["11"]) 
          ? null 
          : (answers["Sleep Patterns"]["11"])
        },
        {
          id: 12,
          text: 'Do you feel rested when you wake up?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Sleep Patterns"] || !answers["Sleep Patterns"]["12"]) 
          ? null 
          : (answers["Sleep Patterns"]["12"])
        },
      ],
    },

    {
      title: 'Stress and Coping Mechanisms',
      questions: [
        {
          id: 13,
          text: 'Do you feel stressed or overwhelmed in your daily life?',
          options: ['Yes', 'No'],
          defaultOption:'No',
          answer: (!answers || !answers["Stress and Coping Mechanisms"] || !answers["Stress and Coping Mechanisms"]["13"]) 
          ? null 
          : (answers["Stress and Coping Mechanisms"]["13"])
        },
        {
          id: 14,
          text: 'How do you usually cope with stress?',
          options: ['Talking to friends/family', 'Exercise', 'Hobbies', 'Professional counseling', 'None of the above'],
          defaultOption:'Exercise',
          answer: (!answers || !answers["Stress and Coping Mechanisms"] || !answers["Stress and Coping Mechanisms"]["14"]) 
          ? null 
          : (answers["Stress and Coping Mechanisms"]["14"])
        },
        {
          id: 15,
          text: 'Do you feel supported by family and friends?',
          options: ['Yes', 'No'],
          defaultOption:'Yes',
          answer: (!answers || !answers["Stress and Coping Mechanisms"] || !answers["Stress and Coping Mechanisms"]["15"]) 
          ? null 
          : (answers["Stress and Coping Mechanisms"]["15"])
        },
      ],
    },
  ];
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!patientVisitFormSection5) return;

    // Define a deep copy to avoid mutating the original state
    const updatedFormSection = [...patientVisitFormSection5];

    // console.log('patientVisitFormSection5: ', patientVisitFormSection5)
    // console.log('updatedFormSection: ', updatedFormSection)
    
    arrayToBind.forEach((section) => {
      // console.log('section: ', section)
      
      section.questions.forEach((question) => {
        const matchingQuestion = updatedFormSection.find(
          (q) => q.question === question.text
        );

        if (matchingQuestion) {
          matchingQuestion.options = question.options;

          // Add followUp if it exists in the input question
          if (question.followUp) {
            matchingQuestion.followUp = question.followUp;
          }
        }
      });
    });
    // console.log('updatedFormSection: ', updatedFormSection)

    // Update the state with the modified array
    setPatientVisitFormSection5(updatedFormSection);
  }, [isOpen]);

  const handleMentalAnswerChange = (value, question) => {
    setAnswers((prevAnswers) => {
      const updatedAnswers = { ...prevAnswers };
      const sectionKey = patientVisitFormSection5.find(
        (item) => item.question === question
      )?.subsectionname;
  
      if (!sectionKey) return updatedAnswers;
  
      updatedAnswers[sectionKey] = {
        ...updatedAnswers[sectionKey],
        [question]: value,
      };
      // console.log('updatedAnswers: ', updatedAnswers)
  
      return updatedAnswers;
    });
  
    // Update the `patientVisitFormSection5` state if needed
    setPatientVisitFormSection5((prev) => {
      if (!prev) return prev;
  
      return prev.map((item) => {
        if (item.question === question) {
          // return { ...item, value };
          return { ...item, value, description: value === 'No' ? null : item.description };
        }
        return item;
      });
    });
  };

  const handleFollowUpChange = (subsectionname, id, value) => {
    setPatientVisitFormSection5((prevState) =>
      prevState.map((item) =>
        item.id === id && item.subsectionname === subsectionname
          ? { ...item, description: value }
          : item
      )
    );
  };

  const handleAddQuestions = async () => {
    const addQuestionsInput = {
      input: {
        doctorid: getLoginID(),
        patientid: patientId,
        visitid: appointmentId,
        visitformdata: patientVisitFormSection5.map((item) => ({
          sectionid: item.sectionid,
          sectionname: item.sectionname,
          subsectionid: item.subsectionid,
          subsectionname: item.subsectionname,
          // questionnumber: item.id, // Assuming `id` represents the question number
          questionnumber: item.questionnumber, 
          question: item.question,
          subquestion: item.subquestion,
          nestedquestion: item.nestedquestion,
          value: answers[item.subsectionname]?.[item.question] || item.value,
          description: item.description,
        })),
      },
    };
    showLoader();
      try {
        const result = await addQuestions(addQuestionsInput.input);
        if (result.output.result == 'success') {
          // getQuestionsList();
          localStorage.removeItem('formState');
          localStorage.removeItem('saveStates');
          localStorage.removeItem('formData');
          localStorage.removeItem('answers')
          localStorage.removeItem('followUps')
          fetchPatientHealthData();
          showSuccessToast("Questions Updated Successfully")
            visitFormSection5.current.closeModal();
        }
        else {
            showErrorToast("Something went wrong!")
          //  dismissLoader();
        }
        dismissLoader();
    } catch (error) {
        console.log(error, "error addQuestion")
    }
    }
// ---------------Mental Screening Editable ends ------------------------------------------
  // ---------------Women Screening Editable starts ------------------------------------------
  const [womenAnswers, setWomenAnswers] = useState({});   

  const arrayToBindForWomen = [
    {
      title: 'Menstrual Health',
      questions: [
        { 
          id: 1, 
          text: 'Do you have regular menstrual periods?', 
          options: ['Yes', 'No'], 
          "subquestion": null,
          "subsectionname": "Menstrual Health",
          followUp: "If no, please specify",
        },
        {
          id: 2,
          options: ['Yes', 'No'],
          "text": 'Have you experienced any of the following menstrual issues?',
          "subquestion": "Heavy periods",
          "subsectionname": "Menstrual Health",
          followUp: "If yes, please specify",
        },
        {
          id: 3,
          "text": "Have you experienced any of the following menstrual issues?",
          "subquestion": "Irregular periods",
          options: ['Yes', 'No'],
                "subsectionname": "Menstrual Health",
          followUp: "If yes, please specify",
        },
        {
          id: 4,
          options: ['Yes', 'No'],
          "text": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Painful periods (dysmenorrhea): ",
                "subsectionname": "Menstrual Health",
          followUp: "If yes, please specify",
        },
        {
          id: 5,
          options: ['Yes', 'No'],
          "text": "Have you experienced any of the following menstrual issues?",
          "subquestion": "Missed periods (amenorrhea)",
                "subsectionname": "Menstrual Health",
          followUp: "If yes, please specify",
        },
        {
          id: 6,
          options: ['Yes', 'No'],
          "text": "Have you experienced any of the following menstrual issues?",
          "subquestion": "Menorrhagia (Prolonged bleeding)",
                "subsectionname": "Menstrual Health",
          followUp: "If yes, please specify",
        },
        {
          id: 7,
          options: ['Yes', 'No'],
          "text": "Are you married?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
        },
        {
          id: 8,
          options: ['Yes', 'No'],
          "text": "Are you currently pregnant?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
                followUp: "If yes, how many weeks?",
        },
        {
          id: 9,
          options: ['Known', 'Unknown'],
          "text": "LMP (Last Menstrual Period)",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
        },
        {
          id: 10,
          "text": "Gravida: How many total pregnancies have you had?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
          followUp: "Value",
        },
        {
          id: 11,
          "text": "Para: How many pregnancies resulted in the birth of a viable infant?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
          followUp: "Value",
        },
        {
          id: 12,
          "text": "Living: How many children are currently living?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
          followUp: "Value",
        },
        {
          id: 13,
          "text": "Abortions: How many pregnancies ended before 20 weeks of gestation?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
          followUp: "Value",
        },
        {
          id: 14,
          "text": "Delivery: How many pregnancies resulted in deliveries (live births or stillbirths)?",
                "subquestion": null,
                "subsectionname": "Menstrual Health",
          followUp: "Value",
        },
        // {
        //   id: 10,
        //   // options: ['Yes', 'No'],
        //   "text": "Number of pregnancies:",
        //         "subquestion": null,
        //         "subsectionname": "Menstrual Health",
        //   followUp: "Value",
        // },
        // {
        //   id: 11,
        //   // options: ['Yes', 'No'],
        //   "text": "Number of live births:",
        //         "subquestion": null,
        //         "subsectionname": "Menstrual Health",
        //   followUp: "Value",
        // },
        // {
        //   id: 12,
        //   options: ['Yes', 'No'],
        //   "text": "Any history of miscarriages or stillbirths?",
        //         "subquestion": null,
        //         "subsectionname": "Menstrual Health",
        //         followUp: "If yes, please describe",
        // },
      ],
    },

    {
      title: 'Gynecological Health',
      questions: [
        { 
          id: 15, 
          options: ['Yes', 'No'],
          "text": "Have you ever been diagnosed with any gynecological conditions (e.g., PCOS, endometriosis, uterine fibroids)?",
          "subquestion": null,
          "subsectionname": "Gynecological Health",
          followUp: "If yes, please specify",
        },
        { 
          id: 16,
          options: ['Yes', 'No'], 
          "text": "Have you undergone a Pap smear test for cervix cancer screening?",
          "subquestion": null,
          "subsectionname": "Gynecological Health",
          followUp: "If yes, when was the last test?",
        },
        { 
          id: 17,
          options: ['Yes', 'No'], 
          "text": "Have you ever had an abnormal Pap smear result?",
          "subquestion": null,
          "subsectionname": "Gynecological Health",
        },
        { 
          id: 18, 
          options: ['Yes', 'No'],
          "text": "Have you undergone an HPV vaccination?",
          "subquestion": null,
          "subsectionname": "Gynecological Health",
        },
        { 
          id: 19, 
          options: ['Yes', 'No'],
          "text": "Have you ever been diagnosed with any sexually transmitted diseases (STDs)?",
          "subquestion": null,
          "subsectionname": "Gynecological Health",
          followUp: "If yes, specify",
        },
      ],
    },

    {
      title: 'Breast Health',
      questions: [
        { 
          id: 20, 
          options: ['Yes', 'No'],
          "text": "Do you perform regular breast self-examinations?",
          "subquestion": null,
          "subsectionname": "Breast Health",
        },
        { 
          id: 21, 
          options: ['Yes', 'No'],
          "text": "Have you ever had a mammogram?",
          "subquestion": null,
          "subsectionname": "Breast Health",
          followUp: "If yes, when was the last one?",
        },
        { 
          id: 22, 
          options: ['Yes', 'No'],
          "text": "Have you experienced any breast changes (e.g., lumps, pain, discharge)?",
          "subquestion": null,
          "subsectionname": "Breast Health",
          followUp: "If yes, please specify",
        },
      ],
    },

    {
      title: 'Reproductive Health and Family Planning',
      questions: [
        { 
          id: 23, 
          options: ['Yes', 'No'],
          "text": "Are you currently using any contraceptives?",
          "subquestion": null,
          "subsectionname": "Reproductive Health and Family Planning",
          followUp: "If yes, which type?",
        },
        { 
          id: 24, 
          options: ['Yes', 'No'],
          "text": "Have you ever had difficulty conceiving (infertility)?",
          "subquestion": null,
          "subsectionname": "Reproductive Health and Family Planning",
          followUp: "If yes, specify the duration",
        },
      ],
    },

    {
      title: 'Menopause',
      questions: [
        { 
          id: 25, 
          options: ['Yes', 'No'],
          "text": "Have you entered menopause (cessation of periods for more than 12 months)?",
          "subquestion": null,
          "subsectionname": "Menopause",
          followUp: "If yes, at what age?",
        },
        { 
          id: 26, 
          options: ['Yes', 'No'],
          "text": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Hot flashes",
                "subsectionname": "Menopause",
        },
        { 
          id: 27, 
          options: ['Yes', 'No'],
          "text": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Night sweats",
                "subsectionname": "Menopause",
        },
        { 
          id: 28, 
          options: ['Yes', 'No'],
          "text": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Mood swings",
                "subsectionname": "Menopause",
        },
        { 
          id: 29, 
          options: ['Yes', 'No'],
          "text": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Vaginal dryness",
                "subsectionname": "Menopause",
        },
        { 
          id: 30, 
          options: ['Yes', 'No'],
          "text": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Sleep disturbances",
                "subsectionname": "Menopause",
        },
        { 
          id: 31, 
          options: ['Yes', 'No'],
          "text": "Are you currently taking hormone replacement therapy (HRT)?",
                "subquestion": null,
                "subsectionname": "Menopause",
        },
      ],
    },
  ];
  const [isWomenOpen, setIsWomenOpen] = useState(false)
  const [LMPChanged, setLMPChanged] = useState(false);
  const [EDDDate, setEDDDate] = useState(null);

  // useEffect(() => {
  //   if (!patientVisitFormSection4) return;

  //   // Clone the state to avoid mutating the original state directly
  //   const updatedFormSection = [...patientVisitFormSection4];
  //   console.log('updatedFormSection Clone: ', updatedFormSection)

  //   arrayToBindForWomen.forEach((section) => {
  //     console.log('section: ', section)
  //     section.questions.forEach((question) => {
  //       // Find the corresponding question in the patientVisitFormSection4 array
  //       const match = updatedFormSection.find(
  //         (q) =>{ 
  //           console.log('q: ', q)
  //           return q.question.trim() === question.text.trim() &&
  //           q.subquestion?.trim() === question.subquestion?.trim()
  //     });

  //       if (match) {
  //         // Add options to the matching object
  //         match.options = question.options || [];

  //         // Add followUp to the matching object if it exists in the input question
  //         if (question.followUp) {
  //           match.followUp = question.followUp;
  //         }
          
  //         // Handle subquestions: Push subquestions into an array
  //         if (question.subquestion) {
  //           if (!match.subquestions) {
  //             match.subquestions = [];
  //           }
  //           match.subquestions.push({
  //             subquestion: question.subquestion,
  //             description: match.description,
  //             value: match.value,
  //           });
  //         }
  //       }
  //     });
  //   });

  //   // Update the state with the modified array
  //   setPatientVisitFormSection4(updatedFormSection);
  //   console.log('patientVisitFormSEction4, , ', patientVisitFormSection4)

  // }, [isWomenOpen]);

  useEffect(() => {
    if (!patientVisitFormSection4 || !Array.isArray(patientVisitFormSection4)) return;
  
    // Create a copy of the current state to avoid direct mutations
    const updatedFormSection = [...patientVisitFormSection4];
  
    arrayToBindForWomen.forEach((section) => {
      section.questions.forEach((question) => {
        // Find the matching question in the patientVisitFormSection4 array
        const match = updatedFormSection.find(
          (q) =>
            q.question.trim() === question.text.trim() &&
            (!question.subquestion || q.subquestion?.trim() === question.subquestion?.trim())
        );
  
        if (match) {
          // Add options directly if they exist
          match.options = question.options || [];
  
          // Add followUp to the matching object if it exists
          if (question.followUp) {
            match.followUp = question.followUp;
          }
  
          // Handle subquestions
          if (question.subquestion) {
            if (!match.subquestions) {
              match.subquestions = [];
            }
            // Push subquestion details into the subquestions array
            match.subquestions.push({
              subquestion: question.subquestion,
              options: question.options || [],
              description: match.description || null,
              text: question.text,
              followUp: question.followUp
            });
  
            // Clear description from the main question object to avoid duplication
            // delete match.description;
          }
        }
      });
    });
  
    // Update the state with the modified array
    setPatientVisitFormSection4(updatedFormSection);
    // console.log('Updated Patient Visit Form Section 4:', updatedFormSection);
  }, [isWomenOpen]);

  useEffect(() => {
    if (!patientVisitFormSection4 || patientVisitFormSection4.length === 0) return;
  
    patientVisitFormSection4.forEach((item) => {
      if (
        item.question === "LMP (Last Menstrual Period)" &&
        item.value === "Known" &&
        item.description
      ) {
        setEDDDate(calculateEDD(item.description));
      }
    });
  }, [patientVisitFormSection4]); 
  const handleChange = (subsec, ques, field, value) => {
          if(field == "lmpDate"){
              var sanitizedVal = formatDate_YYYY_MM_DD(value);
              setEDDDate(calculateEDD(value))
          }
          setPatientVisitFormSection4((prevState) => {
            const newState = prevState.map((item) =>
              item.subsectionname === subsec && item.question === ques
                ? { ...item, description: sanitizedVal }
                : item
            );
            return newState;
          });
      };

  // const handleWomenAnswerChange = (value, question) => {
  //   setWomenAnswers((prevAnswers) => {
  //     const updatedAnswers = { ...prevAnswers };
  //     const sectionKey = patientVisitFormSection4.find(
  //       (item) => item.question === question
  //     )?.subsectionname;
  
  //     if (!sectionKey) return updatedAnswers;
  
  //     updatedAnswers[sectionKey] = {
  //       ...updatedAnswers[sectionKey],
  //       [question]: value,
  //     };
  //     console.log('updatedAnswers: ', updatedAnswers)
  
  //     return updatedAnswers;
  //   });
  
  //   // Update the `patientVisitFormSection5` state if needed
  //   setPatientVisitFormSection4((prev) => {
  //     if (!prev) return prev;
  
  //     return prev.map((item) => {
  //       if (item.question === question) {
  //         return { ...item, value };
  //       }
  //       return item;
  //     });
  //   });
  // };
  const handleWomenAnswerChange = (value, questionId, question) => {
    setPatientVisitFormSection4((prevState) =>
      prevState.map((item) => {
        if (item.id === questionId) {
          // For specific questions, reverse the behavior for 'No'
          if (question === "Do you have regular menstrual periods?") { 
            return { ...item, value, description: value === 'Yes' ? null : item.description };
          }
          // Default behavior for other questions
          return { ...item, value, description: value === 'No' ? null : item.description };
        }
        return item;
      })
    );
  };
  const handleWomenSubAnswerChange = (value, subques) => {
    // console.log('handleWomenSubAnswerChange:', value, subques);
    setPatientVisitFormSection4((prevState) => {
      const newState = prevState.map((item) =>
        item.subquestion === subques
          ? { ...item, value, description: value === 'No' ? null : item.description }
          : item
      );
      // console.log('Updated State:', newState);
      return newState;
    });
  };
  
  const handleWomenSubAnswerFollowUpChange = (subsectionname, subq, id, value) => {
    // console.log('handleWomenSubAnswerFollowUpChange:', subsectionname, subq, id, value);
    setPatientVisitFormSection4((prevState) => {
      const newState = prevState.map((item) =>
        item.subsectionname === subsectionname && item.subquestion === subq
          ? { ...item, description: value }
          : item
      );
      // console.log('Updated State:', newState);
      return newState;
    });
  };
  // const handleWomenSubAnswerFollowUpChange = (subsectionname, subq, id, value) => {
  //   console.log('handleWomenSubAnswerFollowUpChange:', subsectionname, subq, id, value);
  //   setPatientVisitFormSection4((prevState) => {
  //     const newState = prevState.map((item) =>
  //       item.id === id && item.subsectionname === subsectionname && item.subquestion === subq
  //         ? { ...item, description: value }
  //         : item
  //     );
  //     console.log('Updated State:', newState);
  //     return newState;
  //   });
  // };
  // const handleWomenSubAnswerChange = (value, subques) => {
  //   console.log('handleWomenSubAnswerChange:', value, subques);
  //   setPatientVisitFormSection4((prevState) =>
  //     prevState.map((item) =>
  //       // item.subquestion === subques ? { ...item, value } : item
  //       item.subquestion === subques ? { ...item, value, description: value === 'No' ? null : item.description } : item
  //     )
  //   );
  // };
  const handleWomenFollowUpChange = (subsectionname, id, value) => {
    setPatientVisitFormSection4((prevState) =>
      prevState.map((item) =>
        item.id === id && item.subsectionname === subsectionname
          ? { ...item, description: value }
          : item
      )
    );
  };
  // const handleWomenSubAnswerFollowUpChange = (subsectionname, subq, id, value) => {
  //   console.log('subsectionname: ', subsectionname)
  //   console.log('subq: ', subq)
  //   console.log('id: ', id)
  //   console.log('value: ', value)
  //   setPatientVisitFormSection4((prevState) =>
  //     // prevState.map((item) =>
  //     //   item.id === id && item.subsectionname === subsectionname
  //     //     ? { ...item, description: value }
  //     //     : item

  //       // item.id === id && item.question === ques && item.subsectionname === subsectionname
  //       //   ? { ...item, value, description: value === 'No' ? null : item.description }
  //       //   : item

  //       prevState.map((item) =>
  //         item.id === id &&
  //         item.subsectionname === subsectionname &&
  //         item.subquestion === subq
  //           ? { ...item, description: value }
  //           : item
  //       )
  //     )
  // };
  const handleWomenInputsFollowUpChange = (subsectionname, id, value) => {
    setPatientVisitFormSection4((prevState) =>
      prevState.map((item) =>
        item.id === id && item.subsectionname === subsectionname
          ? { ...item, value: value }
          : item
      )
    );
  };

  const handleWomenAddQuestions = async () => {
    const addQuestionsInput = {
      input: {
        doctorid: getLoginID(),
        patientid: patientId,
        visitid: appointmentId,
        visitformdata: patientVisitFormSection4.map((item) => ({
          sectionid: item.sectionid,
          sectionname: item.sectionname,
          subsectionid: item.subsectionid,
          subsectionname: item.subsectionname,
          // questionnumber: item.id, // Assuming `id` represents the question number
          questionnumber: item.questionnumber, 
          question: item.question,
          subquestion: item.subquestion,
          nestedquestion: item.nestedquestion,
          value: womenAnswers[item.subsectionname]?.[item.question] || item.value,
          description: item.description,
        })),
      },
    };
    showLoader();
      try {
        const result = await addQuestions(addQuestionsInput.input);
        if (result.output.result == 'success') {
          // getQuestionsList();
          localStorage.removeItem('formState');
          localStorage.removeItem('saveStates');
          localStorage.removeItem('formData');
          localStorage.removeItem('answers')
          localStorage.removeItem('followUps')
          fetchPatientHealthData();
          showSuccessToast("Questions Updated Successfully")
            visitFormSection4.current.closeModal();
        }
        else {
            showErrorToast("Something went wrong!")
          //  dismissLoader();
        }
        dismissLoader();
    } catch (error) {
        console.log(error, "error addQuestion")
    }
    }
// ---------------Women Screening Editable ends ------------------------------------------
  // ---------------Adult Screening Editable starts ------------------------------------------
  const [adultAnswers, setAdultAnswers] = useState({});  

  const arrayToBindForAdult = [
    {
      title: 'Symptom Screening',
      questions: [
        { 
          id: 1, 
          options: ['yes', 'no'], 
          "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Fatigue",
        },
        {
          id: 2,
          options: ['yes', 'no'],
         "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Dizziness",
        },
        {
          id: 3,
          options: ['yes', 'no'],
          "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Chest Pain",
        },
        {
          id: 4,
          options: ['yes', 'no'],
          "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Shortness of Breath",
        },
        {
          id: 5,
          options: ['yes', 'no'],
          "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Persistent Cough",
        },
        {
          id: 6,
          options: ['yes', 'no'],
          "subsectionname": "Symptom Screening",
        "text": "Have you experienced any of the following symptoms recently?",
        "subquestion": "Unexplained Weight Loss",
        },
      ],
    },

    {
      title: 'Preventive Health Screening',
      questions: [
        { 
          id: 7, 
          options: ['done', 'not done'], 
          "subsectionname": "Preventive Health Screening",
        "text": "Prostate Cancer Screening (for men)",
        // "text": "Cervix and Breast Cancer Screening (for women)",
        "subquestion": null,
        },
        { 
          id: 8, 
          options: ['done', 'not done'], 
          "subsectionname": "Preventive Health Screening",
        // "text": "Prostate Cancer Screening (for men)",
        "text": "Cervix and Breast Cancer Screening (for women)",
        "subquestion": null,
        },
      ],
    },

    
  ];
  const [isAdultOpen, setIsAdultOpen] = useState(false)

  useEffect(() => {
    if (!patientVisitFormSection2) return;

    // Clone the state to avoid mutating the original state directly
    const updatedFormSection = [...patientVisitFormSection2];

    arrayToBindForAdult.forEach((section) => {
      section.questions.forEach((question) => {
        // Find the corresponding question in the patientVisitFormSection4 array
        const match = updatedFormSection.find(
          (q) => q.question.trim() === question.text.trim()
        );

        if (match) {
          // Add options to the matching object
          match.options = question.options || [];
          
          // Handle subquestions: Push subquestions into an array
          if (question.subquestion) {
            if (!match.subquestions) {
              match.subquestions = [];
            }
            match.subquestions.push({
              subquestion: question.subquestion,
              value: match.value,
            });
          }
        }
      });
    });

    // Update the state with the modified array
    setPatientVisitFormSection2(updatedFormSection);

  }, [isAdultOpen]);

  const handleAdultAnswerChange = (value, questionId) => {
    setPatientVisitFormSection2((prevState) =>
      prevState.map((item) =>
        item.id === questionId ? { ...item, value } : item
      )
    );
  };
  const handleAdultSubAnswerChange = (value, subques) => {
    setPatientVisitFormSection2((prevState) =>
      prevState.map((item) =>
        item.subquestion === subques ? { ...item, value } : item
      )
    );
  };

  const handleAdultAddQuestions = async () => {
    const addQuestionsInput = {
      input: {
        doctorid: getLoginID(),
        patientid: patientId,
        visitid: appointmentId,
        visitformdata: patientVisitFormSection2.map((item) => ({
          sectionid: item.sectionid,
          sectionname: item.sectionname,
          subsectionid: item.subsectionid,
          subsectionname: item.subsectionname,
          questionnumber: item.questionnumber, 
          question: item.question,
          subquestion: item.subquestion,
          nestedquestion: item.nestedquestion,
          value: adultAnswers[item.subsectionname]?.[item.question] || item.value,
          description: item.description,
        })),
      },
    };
    showLoader();
      try {
        const result = await addQuestions(addQuestionsInput.input);
        if (result.output.result == 'success') {
          fetchPatientHealthData();
          showSuccessToast("Questions Updated Successfully")
            visitFormSection2.current.closeModal();
        }
        else {
            showErrorToast("Something went wrong!")
          //  dismissLoader();
        }
        dismissLoader();
    } catch (error) {
        console.log(error, "error addQuestion")
    }
    }
// ---------------Adult Screening Editable ends ------------------------------------------

// ---------------Infant Screening Editable starts ------------------------------------------
const [infantAnswers, setInfantAnswers] = useState({});  

const arrayToBindForInfant = [
  {
    title: 'Pregnancy & Birth History',
    questions: [
      {
        id: 1,
        options: [],
        type: "checkbox",
        "subsectionname": "Pregnancy & Birth History",
  "text": "Pregnancy & Birth History",
  "subquestion": "Gestational Diabetes",
      },
      {
        id: 2,
        options: [],
        type: "checkbox",
        "subsectionname": "Pregnancy & Birth History",
  "text": "Pregnancy & Birth History",
  "subquestion": "HTN (Hypertension)",
      },
      {
        id: 3,
        options: [],
        type: "checkbox",
        "subsectionname": "Pregnancy & Birth History",
  "text": "Pregnancy & Birth History",
  "subquestion": "Hyperthyroidism",
      },
      {
        id: 4,
        options: [],
        type: "checkbox",
        "subsectionname": "Pregnancy & Birth History",
  "text": "Pregnancy & Birth History",
  "subquestion": "Infections",
      },
      {
        id: 5,
        options: [],
        type: "checkbox",
        "subsectionname": "Pregnancy & Birth History",
  "text": "Pregnancy & Birth History",
  "subquestion": "Others",
  followUp: "If yes, please specify",
      },
    ],
  },

  // {
  //   title: 'Pregnancy & Birth History',
  //   questions: [
  //     {
  //       id: 1,
  //       options: ["Yes", "No"],
  //       type: "checkbox",
  //       "subsectionname": "Pregnancy & Birth History",
  // "text": "Gestational Diabetes",
  // "subquestion": null,
  //     },
  //     {
  //       id: 2,
  //       options: ["Yes", "No"],
  //       type: "checkbox",
  //       "subsectionname": "Pregnancy & Birth History",
  // "text": "HTN (Hypertension)",
  // "subquestion": null,
  //     },
  //     {
  //       id: 3,
  //       options: ["Yes", "No"],
  //       type: "checkbox",
  //       "subsectionname": "Pregnancy & Birth History",
  // "text": "Hyperthyroidism",
  // "subquestion": null,
  //     },
  //     {
  //       id: 4,
  //       options: ["Yes", "No"],
  //       type: "checkbox",
  //       "subsectionname": "Pregnancy & Birth History",
  // "text": "Infections",
  // "subquestion": null,
  //     },
  //     {
  //       id: 5,
  //       options: ["Yes", "No"],
  //       type: "checkbox",
  //       "subsectionname": "Pregnancy & Birth History",
  // "text": "Others",
  // "subquestion": null,
  // followUp: "If yes, please specify",
  //     },
  //   ],
  // },

  {
    title: 'Pregnancy Duration',
    questions: [
      {
        id: 6,
        options: ["Full Term", "Pre-Term", "Post Term"],
        "subsectionname": "Pregnancy Duration",
  "text": "How would you categorize the duration of the pregnancy?",
  "subquestion": null,
      },
    ],
  },

  {
    title: 'Mode of Delivery',
    questions: [
      {
        id: 7,
        options: ["NVD", "C Section", "Spontaneous", "Induced"],
        "subsectionname": "Mode of Delivery",
  "text": "What was the mode of delivery?",
  "subquestion": null,
      },
    ],
  },

  {
    title: 'Birth Complications',
    questions: [
      {
        id: 8,
        options: [],
        type: "checkbox",
        "subsectionname": "Birth Complications",
  "text": "Birth Complications",
  "subquestion": "Asphyxia",
      },
      {
        id: 9,
        options: [],
        type: "checkbox",
        "subsectionname": "Birth Complications",
  "text": "Birth Complications",
  "subquestion": "Jaundice",
      },
      {
        id: 10,
        options: [],
        type: "checkbox",
        "subsectionname": "Birth Complications",
  "text": "Birth Complications",
  "subquestion": "Congenital Anomalies",

      },
      {
        id: 11,
        options: [],
        type: "checkbox",
        "subsectionname": "Birth Complications",
  "text": "Birth Complications",
  "subquestion": "Others",
  followUp: "If yes, please specify",
      },
    ],
  },

  {
    title: 'History of NICU Admission',
    questions: [
      {
        id: 12,
        options: ["Yes", "No"],
        "subsectionname": "History of NICU Admission",
  "text": "Is there a history of NICU admission?",
  "subquestion": null,
      },
    ],
  },

  {
    title: 'Growth and Development',
    questions: [
      { 
        id: 15, 
        options: [],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Weight-for-Age (WAZ)",
  followUp: "Enter value",
      },
      { 
        id: 16, 
        options: [],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Height-for-Age (HAZ)",
  followUp: "Enter value",
      },
      { 
        id: 17, 
        options: [],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Weight-for-Height (WHZ)",
  followUp: "Enter value",
      },
      { 
        id: 18, 
        options: ['Normal', 'Stunted'],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Stunting (HAZ < -2)",
      },
      { 
        id: 19, 
        options: ['Normal', 'Wasted'],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Wasting (WHZ < -2)",
      },
      { 
        id: 20, 
        options: ['Normal', 'Underweight'],
        "subsectionname": "Growth and Development",
  "text": "According to the WHO Growth Standards",
  "subquestion": "Underweight (WAZ < -2)",
      },
    ],
  },

  {
    title: 'Feeding History',
    questions: [
      {
        id: 21,
        options: ["EXDBF", "Formula", "Mixed"],
        "subsectionname": "Feeding History",
  "text": "What type of feeding does the baby receive?",
  "subquestion": null,
      },
    ],
  },
];
const [isInfantOpen, setIsInfantOpen] = useState(false)
useEffect(() => {
  if (!patientVisitFormSection6) return;

  // Clone the state to avoid mutating the original state directly
  const updatedFormSection = patientVisitFormSection6.map((item) => ({ ...item }));

  arrayToBindForInfant.forEach((section) => {
    console.log('section: ', section)
    section.questions.forEach((question) => {
      // Find the corresponding question in the patientVisitFormSection3 array
      const match = updatedFormSection.find(
        (q) =>
          q.question.trim() === question.text.trim() &&
          q.subquestion === question.subquestion
      );

      if (match) {
        // Add options to the matching object
        match.options = question.options || [];
        match.type = question.type ;

        // Add followUp to the matching object if it exists in the input question
        if (question.followUp) {
          match.followUp = question.followUp;
        }

        // Handle subquestions: Push subquestions into an array
        if (question.subquestion) {
          if (!match.subquestions) {
            match.subquestions = [];
          }
          match.subquestions.push({
            subquestion: question.subquestion,
            value: match.value,
            options : question.options || [],
            type: question.type
          });
        }
      }
    });
  });

  // Update the state with the modified array
  setPatientVisitFormSection6(updatedFormSection);
  // console.log('updatedFormSEction Three 6: ', updatedFormSection)
}, [isInfantOpen]);


// useEffect(() => {
//   if (!patientVisitFormSection3) return;

//   // Clone the state to avoid mutating the original state directly
//   const updatedFormSection = [...patientVisitFormSection3];
//   console.log('updatedFormSection: ', updatedFormSection)

//   arrayToBindForChild.forEach((section) => {
//     console.log('section: ', section)
//     section.questions.forEach((question) => {
//       // Find the corresponding question in the patientVisitFormSection4 array
//       const match = updatedFormSection.find(
//         (q) => q.question.trim() === question.question.trim()
//       );

//       if (match) {
//         // Add options to the matching object
//         match.options = question.options || [];
        
//         // Handle subquestions: Push subquestions into an array
//         if (question.subquestion) {
//           if (!match.subquestions) {
//             match.subquestions = [];
//           }
//           match.subquestions.push({
//             subquestion: question.subquestion,
//             value: match.value,
//           });
//         }
//       }

//       // if (match) {
//       //   // Add options and subquestion to the matching object
//       //   match.options = question.options || [];
//       //   match.subquestion = question.subquestion || null;
//       // }
//     });
//   });

//   // Update the state with the modified array
//   setPatientVisitFormSection3(updatedFormSection);
//   console.log('patientVisitFormSEction4, , ', patientVisitFormSection3)

// }, [isChildOpen]);

// const handleWomenAnswerChange = (value, question) => {
//   setWomenAnswers((prevAnswers) => {
//     const updatedAnswers = { ...prevAnswers };
//     const sectionKey = patientVisitFormSection4.find(
//       (item) => item.question === question
//     )?.subsectionname;

//     if (!sectionKey) return updatedAnswers;

//     updatedAnswers[sectionKey] = {
//       ...updatedAnswers[sectionKey],
//       [question]: value,
//     };
//     console.log('updatedAnswers: ', updatedAnswers)

//     return updatedAnswers;
//   });

//   // Update the `patientVisitFormSection5` state if needed
//   setPatientVisitFormSection4((prev) => {
//     if (!prev) return prev;

//     return prev.map((item) => {
//       if (item.question === question) {
//         return { ...item, value };
//       }
//       return item;
//     });
//   });
// };
const handleInfantAnswerChange = (value, questionId) => {
  setPatientVisitFormSection6((prevState) =>
    prevState.map((item) =>
      item.id === questionId 
          ? { ...item, value, description: value === 'No' ? null : item.description } 
          : item
    )
  );
};
// const handleInfantSubAnswerChange = (value, subques) => {
//   setPatientVisitFormSection6((prevState) =>
//     prevState.map((item) =>
//       item.subquestion === subques ? { ...item, value } : item
//     )
//   );
// };

const handleInfantSubAnswerChange = (isChecked, subques, subsecname) => {
  setPatientVisitFormSection6((prevState) =>
    prevState.map((item) =>
      item.subquestion === subques && item.subsectionname === subsecname
        ? { ...item, value: isChecked ? subques : null ,
          description: isChecked ? item.description : null 

        } // Set value to subquestion if checked, otherwise null
        : item
    )
  );
};

const handleInfantCheckboxChange = (value, questionId) => {
  setPatientVisitFormSection6((prevState) =>
    prevState.map((item) =>
      item.id === questionId 
          ? { ...item, value: value } 
          : item
    )
  );
};
const handleInfantOthersInputsFollowUpChange = (subsectionname, subques, value) => {
  // console.log('subsectionname', subsectionname)
  // console.log('subques', subques)
  // console.log('value', value)
  setPatientVisitFormSection6((prevState) =>
    prevState.map((item) =>
      item.subquestion === subques && item.subsectionname === subsectionname
        ? { ...item, description: value }
        : item
    )
  );
};
const handleInfantInputsFollowUpChange = (subsectionname, id, value) => {
  // console.log('subsectionname', subsectionname)
  // console.log('id', id)
  // console.log('value', value)
  setPatientVisitFormSection6((prevState) =>
    prevState.map((item) =>
      item.id === id && item.subsectionname === subsectionname
        ? { ...item, description: value }
        : item
    )
  );
};

// const handleChildFollowUpChange = (subsectionname, id, value) => {
//   console.log("Follow-up input value:", value);
//   console.log("Subsection:", subsectionname, "ID:", id);

//   setPatientVisitFormSection3((prevState) => {
//     if (!prevState) {
//       console.error("prevState is undefined or null!");
//       return [];
//     }

//     const updatedState = prevState.map((item) =>
//       item.id === id && item.subsectionname === subsectionname
//         ? { ...item, description: value }
//         : item
//     );

//     console.log("Updated state inside setState:", updatedState);
//     return updatedState;
//   });
// };

const handleInfantFollowUpChange = (subsectionname, id, value) => {
  setPatientVisitFormSection6((prevState) =>
    prevState?.map((item) =>
      item.id === id && item.subsectionname === subsectionname
        ? { ...item, description: value }
        : item
    )
  );
};

const handleInfantAddQuestions = async () => {
  const addQuestionsInput = {
    input: {
      doctorid: getLoginID(),
      patientid: patientId,
      visitid: appointmentId,
      visitformdata: patientVisitFormSection6.map((item) => ({
        sectionid: item.sectionid,
        sectionname: item.sectionname,
        subsectionid: item.subsectionid,
        subsectionname: item.subsectionname,
        // questionnumber: item.id, // Assuming `id` represents the question number
        questionnumber: item.questionnumber, 
        question: item.question,
        subquestion: item.subquestion,
        nestedquestion: item.nestedquestion,
        value: infantAnswers[item.subsectionname]?.[item.question] || item.value,
        description: item.description,
      })),
    },
  };
  showLoader();
    try {
      const result = await addQuestions(addQuestionsInput.input);
      if (result.output.result == 'success') {
        // getQuestionsList();
        localStorage.removeItem('formState');
        localStorage.removeItem('saveStates');
        localStorage.removeItem('formData');
        localStorage.removeItem('answers')
        localStorage.removeItem('followUps')
        fetchPatientHealthData();
        showSuccessToast("Questions Updated Successfully")
          visitFormSection6.current.closeModal();
      }
      else {
          showErrorToast("Something went wrong!")
        //  dismissLoader();
      }
      dismissLoader();
  } catch (error) {
      console.log(error, "error addQuestion")
  }
  }
// ---------------Infant Screening Editable ends --------------------------------------

  // ---------------Children Screening Editable starts ------------------------------------------
  const [childAnswers, setChildAnswers] = useState({});  

  const arrayToBindForChild = [
    {
      title: 'Growth and Development',
      questions: [
        { 
          id: 1, 
          options: [],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Weight-for-Age (WAZ)",
    followUp: "Enter value",
        },
        { 
          id: 2, 
          options: [],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Height-for-Age (HAZ)",
    followUp: "Enter value",
        },
        { 
          id: 3, 
          options: [],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Weight-for-Height (WHZ)",
    followUp: "Enter value",
        },
        { 
          id: 4, 
          options: ['Normal', 'Stunted'],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Stunting (HAZ < -2)",
        },
        { 
          id: 5, 
          options: ['Normal', 'Wasted'],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Wasting (WHZ < -2)",
        },
        { 
          id: 6, 
          options: ['Normal', 'Underweight'],
          "subsectionname": "Growth and Development",
    "text": "According to the WHO Growth Standards",
    "subquestion": "Underweight (WAZ < -2)",
        },
      ],
    },

    {
      title: 'WHO Growth Questions',
      questions: [
        {
          id: 7,
          options: ['Yes', 'No'],
          "subsectionname": "WHO Growth Questions",
    "text": "Has your child experienced any growth-related concerns (e.g., delayed growth, slow weight gain, or being smaller for age)?",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 8,
          options: ['Yes', 'No'],
          "subsectionname": "WHO Growth Questions",
    "text": "Is your child’s growth monitored regularly (e.g., through routine health check-ups)?",
    "subquestion": null,
        },
        {
          id: 9,
          options: ["Increased", "Decreased", "No Change"],
          "subsectionname": "WHO Growth Questions",
    "text": "Has your child’s weight increased or decreased unexpectedly in the last 6 months?",
    "subquestion": null,
        },
        {
          id: 10,
          options: ['Yes', 'No'],
          "subsectionname": "WHO Growth Questions",
    "text": "Does your child have difficulty in eating or have a reduced appetite?",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 11,
          options: ['Yes', 'No'],
          "subsectionname": "WHO Growth Questions",
    "text": "Has your child been hospitalized or received treatment for any malnutrition-related conditions?",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
      ],
    },

    {
      title: 'General Health Information',
      questions: [
        {
          id: 12,
          options: ['Yes', 'No'],
          "subsectionname": "General Health Information",
    "text": "Does your child have any known allergies?",
    "subquestion": null,
        },
        {
          id: 13,
          options: ['Yes', 'No'],
          "subsectionname": "General Health Information",
    "text": "Has your child experienced any major illnesses?",
    "subquestion": null,
        },    
        {
          id: 14,
          options: ['Yes', 'No'],
          "subsectionname": "General Health Information",
    "text": "Is your child up to date with vaccinations? ",
    "subquestion": null,
        },
      ],
    },

    {
      title: 'Symptom Screening',
      questions: [
        {
          id: 15,
          options: ['Yes', 'No'],
          "subsectionname": "Symptom Screening",
    "text": "Has your child experienced any of the following symptoms recently?",
    "subquestion": "Frequent Colds or Infections",
        },
        {
          id: 16,
          options: ['Yes', 'No'],
          "subsectionname": "Symptom Screening",
    "text": "Has your child experienced any of the following symptoms recently?",
    "subquestion": "Fever",
        },
        {
          id: 17,
          options: ['Yes', 'No'],
          "subsectionname": "Symptom Screening",
    "text": "Has your child experienced any of the following symptoms recently?",
    "subquestion": "Shortness of Breath",
        },
        {
          id: 18,
          options: ['Yes', 'No'],
          "subsectionname": "Symptom Screening",
    "text": "Has your child experienced any of the following symptoms recently?",
    "subquestion": "Vomiting or Diarrhea",
        },
        {
          id: 19,
          options: ['Yes', 'No'],
          "subsectionname": "Symptom Screening",
    "text": "Has your child experienced any of the following symptoms recently?",
    "subquestion": "Fatigue or Lethargy",
        },
      ],
    },

    {
      title: 'Nutrition and Eating Habits',
      questions: [
        {
          id: 20,
          options: ['Yes', 'No'],
          "subsectionname": "Nutrition and Eating Habits",
    "text": "Does your child have a balanced diet?",
    "subquestion": null,
        },
        {
          id: 21,
          options: ["Daily", "Sometimes", "Rarely"],
          "subsectionname": "Nutrition and Eating Habits",
    "text": "How often does your child consume the following?",
    "subquestion": "Fruits",
        },
        {
          id: 22,
          options: ["Daily", "Sometimes", "Rarely"],
          "subsectionname": "Nutrition and Eating Habits",
    "text": "How often does your child consume the following?",
    "subquestion": "Vegetables",
        },
        {
          id: 23,
          options: ["Daily", "Sometimes", "Rarely"],
          "subsectionname": "Nutrition and Eating Habits",
    "text": "How often does your child consume the following?",
    "subquestion": "Meat or Proteins",
        },
        {
          id: 24,
          options: ["Daily", "Sometimes", "Rarely"],
          "subsectionname": "Nutrition and Eating Habits",
    "text": "How often does your child consume the following?",
    "subquestion": "Dairy Products",
        },
      ],
    },
    
    {
      title: 'Family Medical History',
      questions: [
        {
          id: 25,
          options: ['Yes', 'No'],
          "subsectionname": "Family Medical History",
    "text": "Is there any family history of the following conditions?",
    "subquestion": "Diabetes",
        },
        {
          id: 26,
          options: ['Yes', 'No'],
          "subsectionname": "Family Medical History",
    "text": "Is there any family history of the following conditions?",
    "subquestion": "Hypertension",
        },
        {
          id: 27,
          options: ['Yes', 'No'],
          "subsectionname": "Family Medical History",
    "text": "Is there any family history of the following conditions?",
    "subquestion": "Asthma",
        },
        {
          id: 28,
          options: ['Yes', 'No'],
          "subsectionname": "Family Medical History",
    "text": "Is there any family history of the following conditions?",
    "subquestion": "Heart Disease",
        },
      ],
    },

    {
      title: 'School Performance',
      questions: [
        {
          id: 29,
          options: ['Yes', 'No'],
          "subsectionname": "School Performance",
    "text": "Does your child attend school regularly?",
    "subquestion": null,
        },
        {
          id: 30,
          options: ['Yes', 'No'],
          "subsectionname": "School Performance",
    "text": "Are there any concerns regarding your child’s school performance?",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
      ],
    },

    {
      title: 'Developmental Concerns',
      questions: [
        {
          id: 31,
          options: ['Yes', 'No'],
          "subsectionname": "Developmental Concerns",
    "text": "Speech Therapy",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 32,
          options: ['Yes', 'No'],
          "subsectionname": "Developmental Concerns",
    "text": "ADHD",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 33,
          options: ['Yes', 'No'],
          "subsectionname": "Developmental Concerns",
    "text": "Early Intervention",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 34,
          options: ['Yes', 'No'],
          "subsectionname": "Developmental Concerns",
    "text": "Autism spectrum disorder",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        {
          id: 35,
          options: ['Yes', 'No'],
          "subsectionname": "Developmental Concerns",
    "text": "Down Syndrome",
    "subquestion": null,
    followUp: "If yes, please specify",
        },
        
      ],
    },

    {
      title: 'History of PICA',
      questions: [
        {
          id: 36,
          options: ['Yes', 'No'],
          "subsectionname": "History of PICA",
    "text": "Does the child have a history of PICA?",
    "subquestion": null,
        },        
      ],
    },

    {
      title: 'History of Nephrotic Syndrome',
      questions: [
        {
          id: 37,
          options: ['Yes', 'No'],
          "subsectionname": "History of Nephrotic Syndrome",
    "text": "Does the child have a history of Nephrotic Syndrome?",
    "subquestion": null,
        },        
      ],
    },
  ];
  const [isChildOpen, setIsChildOpen] = useState(false)
  useEffect(() => {
    if (!patientVisitFormSection3) return;
  
    // Clone the state to avoid mutating the original state directly
    const updatedFormSection = patientVisitFormSection3.map((item) => ({ ...item }));
  
    arrayToBindForChild.forEach((section) => {
      console.log('section: ', section)
      section.questions.forEach((question) => {
        // Find the corresponding question in the patientVisitFormSection3 array
        const match = updatedFormSection.find(
          (q) =>
            q.question.trim() === question.text.trim() &&
            q.subquestion === question.subquestion
        );
  
        if (match) {
          // Add options to the matching object
          match.options = question.options || [];

          // Add followUp to the matching object if it exists in the input question
          if (question.followUp) {
            match.followUp = question.followUp;
          }
  
          // Handle subquestions: Push subquestions into an array
          if (question.subquestion) {
            if (!match.subquestions) {
              match.subquestions = [];
            }
            match.subquestions.push({
              subquestion: question.subquestion,
              value: match.value,
              options : question.options || []
            });
          }
        }
      });
    });
  
    // Update the state with the modified array
    setPatientVisitFormSection3(updatedFormSection);
    console.log('updatedFormSEction Three 3: ', updatedFormSection)
  }, [isChildOpen]);
  

  // useEffect(() => {
  //   if (!patientVisitFormSection3) return;

  //   // Clone the state to avoid mutating the original state directly
  //   const updatedFormSection = [...patientVisitFormSection3];
  //   console.log('updatedFormSection: ', updatedFormSection)

  //   arrayToBindForChild.forEach((section) => {
  //     console.log('section: ', section)
  //     section.questions.forEach((question) => {
  //       // Find the corresponding question in the patientVisitFormSection4 array
  //       const match = updatedFormSection.find(
  //         (q) => q.question.trim() === question.question.trim()
  //       );

  //       if (match) {
  //         // Add options to the matching object
  //         match.options = question.options || [];
          
  //         // Handle subquestions: Push subquestions into an array
  //         if (question.subquestion) {
  //           if (!match.subquestions) {
  //             match.subquestions = [];
  //           }
  //           match.subquestions.push({
  //             subquestion: question.subquestion,
  //             value: match.value,
  //           });
  //         }
  //       }

  //       // if (match) {
  //       //   // Add options and subquestion to the matching object
  //       //   match.options = question.options || [];
  //       //   match.subquestion = question.subquestion || null;
  //       // }
  //     });
  //   });

  //   // Update the state with the modified array
  //   setPatientVisitFormSection3(updatedFormSection);
  //   console.log('patientVisitFormSEction4, , ', patientVisitFormSection3)

  // }, [isChildOpen]);

  // const handleWomenAnswerChange = (value, question) => {
  //   setWomenAnswers((prevAnswers) => {
  //     const updatedAnswers = { ...prevAnswers };
  //     const sectionKey = patientVisitFormSection4.find(
  //       (item) => item.question === question
  //     )?.subsectionname;
  
  //     if (!sectionKey) return updatedAnswers;
  
  //     updatedAnswers[sectionKey] = {
  //       ...updatedAnswers[sectionKey],
  //       [question]: value,
  //     };
  //     console.log('updatedAnswers: ', updatedAnswers)
  
  //     return updatedAnswers;
  //   });
  
  //   // Update the `patientVisitFormSection5` state if needed
  //   setPatientVisitFormSection4((prev) => {
  //     if (!prev) return prev;
  
  //     return prev.map((item) => {
  //       if (item.question === question) {
  //         return { ...item, value };
  //       }
  //       return item;
  //     });
  //   });
  // };
  const handleChildAnswerChange = (value, questionId) => {
    setPatientVisitFormSection3((prevState) =>
      prevState.map((item) =>
        item.id === questionId 
            ? { ...item, value, description: value === 'No' ? null : item.description } 
            : item
      )
    );
  };
  const handleChildSubAnswerChange = (value, subques) => {
    setPatientVisitFormSection3((prevState) =>
      prevState.map((item) =>
        item.subquestion === subques ? { ...item, value } : item
      )
    );
  };
  const handleChildInputsFollowUpChange = (subsectionname, id, value) => {
    setPatientVisitFormSection3((prevState) =>
      prevState.map((item) =>
        item.id === id && item.subsectionname === subsectionname
          ? { ...item, value: value }
          : item
      )
    );
  };

  // const handleChildFollowUpChange = (subsectionname, id, value) => {
  //   console.log("Follow-up input value:", value);
  //   console.log("Subsection:", subsectionname, "ID:", id);
  
  //   setPatientVisitFormSection3((prevState) => {
  //     if (!prevState) {
  //       console.error("prevState is undefined or null!");
  //       return [];
  //     }
  
  //     const updatedState = prevState.map((item) =>
  //       item.id === id && item.subsectionname === subsectionname
  //         ? { ...item, description: value }
  //         : item
  //     );
  
  //     console.log("Updated state inside setState:", updatedState);
  //     return updatedState;
  //   });
  // };

  const handleChildFollowUpChange = (subsectionname, id, value) => {
    setPatientVisitFormSection3((prevState) =>
      prevState?.map((item) =>
        item.id === id && item.subsectionname === subsectionname
          ? { ...item, description: value }
          : item
      )
    );
  };

  const handleChildAddQuestions = async () => {
    const addQuestionsInput = {
      input: {
        doctorid: getLoginID(),
        patientid: patientId,
        visitid: appointmentId,
        visitformdata: patientVisitFormSection3.map((item) => ({
          sectionid: item.sectionid,
          sectionname: item.sectionname,
          subsectionid: item.subsectionid,
          subsectionname: item.subsectionname,
          // questionnumber: item.id, // Assuming `id` represents the question number
          questionnumber: item.questionnumber, 
          question: item.question,
          subquestion: item.subquestion,
          nestedquestion: item.nestedquestion,
          value: childAnswers[item.subsectionname]?.[item.question] || item.value,
          description: item.description,
        })),
      },
    };
    showLoader();
      try {
        const result = await addQuestions(addQuestionsInput.input);
        if (result.output.result == 'success') {
          // getQuestionsList();
          localStorage.removeItem('formState');
          localStorage.removeItem('saveStates');
          localStorage.removeItem('formData');
          localStorage.removeItem('answers')
          localStorage.removeItem('followUps')
          fetchPatientHealthData();
          showSuccessToast("Questions Updated Successfully")
            visitFormSection3.current.closeModal();
        }
        else {
            showErrorToast("Something went wrong!")
          //  dismissLoader();
        }
        dismissLoader();
    } catch (error) {
        console.log(error, "error addQuestion")
    }
    }
// ---------------Children Screening Editable ends ------------------------------------------

// ---------------Child Screening Editable starts ------------------------------------------

// const questionnaire = [
//   {
//     section: "Growth and Development",
//     questions: [
//       {
//         question: "According to the WHO Growth Standards",
//         subquestions: [
//           { question: "Height (in cm)", unit: "cm",  },
//           { question: "Weight (in kg)", unit: "kg", },
//           {
//             question: "Z-Scores (WHO Growth Standards):",
//             subquestions: [
//               { question: "Weight-for-Age (WAZ)",  },
//               //  { question: "Weight-for-Age (WAZ)", answer: zScoreHAZ },
//               { question: "Height-for-Age (HAZ)",  },
//               { question: "Weight-for-Height (WHZ)",  },
//               { question: "Stunting (HAZ < -2)", 
//                 // answer: stunting, 
//                 options: ["Normal", "Stunted"], },
//               { question: "Wasting (WHZ < -2)", 
//                 // answer: wasting, 
//                 options: ["Normal", "Wasted"], },
//               { question: "Underweight (WAZ < -2)", 
//                 // answer: underweight, 
//                 options: ["Normal", "Underweight"], },
//             ],
//           },

//         ],
//       },
//       {
//         question: "WHO Growth Questions",
//         subquestions: [
//           {
//             question: "Has your child experienced any growth-related concerns (e.g., delayed growth, slow weight gain, or being smaller for age)?",
//             // answer: growthConcerns ? growthConcerns : 'No',
//             options: ["Yes", "No"],
//             // moreinfo: { question: "If yes, please specify", answer: growthConcernsDesc },
//           },

//           {
//             question: "Is your child’s growth monitored regularly (e.g., through routine health check-ups)?",
//             // answer: growthMonitored ? growthMonitored : 'Yes',
//             options: ["Yes", "No"],
//           },
//           {
//             question: "Has your child’s weight increased or decreased unexpectedly in the last 6 months?",
//             // answer: weightChange ? weightChange : 'Increased',
//             options: ["Increased", "Decreased", "No Change"],
//           },
//           {
//             question: "Does your child have difficulty in eating or have a reduced appetite?",
//             // answer: eatingDifficulty ? eatingDifficulty : 'No',
//             options: ["Yes", "No"],
//             // moreinfo: { question: "If yes, please specify", answer: eatingDifficultyDesc },
//           },
//           {
//             question: "Has your child been hospitalized or received treatment for any malnutrition-related conditions?",
//             // answer: malnutritionTreatment ? malnutritionTreatment : 'No',
//             options: ["Yes", "No"],
//             // moreinfo: { question: "If yes, please specify", answer: malnutritionTreatmentDesc },
//           },

//         ],
//       },
//       {
//         question: "General Health Information",
//         subquestions: [
//           {
//             question: "Does your child have any known allergies? ",
//             // answer: knownAllergies ? knownAllergies : "No",
//             options: ["Yes", "No"],
//             // moreinfo: { question: "If yes, please specify", answer: knownAllergyDesc },
//           },
//           {
//             question: "Has your child experienced any major illnesses? ",
//             // answer: majorIllness ? majorIllness : 'No',
//             options: ["Yes", "No"],
//             // moreinfo: { question: "If yes, please specify", answer: majorIllnessDetails },
//           },
//           {
//             question: "Is your child up to date with vaccinations?",
//             // answer: vaccinationsUpToDate,
//             options: ["Yes", "No"],
//             moreinfo: { question: "If yes, please specify", answer: null },
//           },
//         ]
//       },
//       {
//         question: "Has your child experienced any of the following symptoms recently?",
//         subquestions: [
//           { question: "Frequent Colds or Infections", 
//             // answer: coldState ? coldState : 'No',
//              options: ["Yes", "No"] },
//           { question: "Fever", 
//             // answer: feverState ? feverState : 'No',
//              options: ["Yes", "No"] },
//           { question: "Shortness of Breath", 
//             // answer: breathState ? breathState : 'No', 
//             options: ["Yes", "No"] },
//           { question: "Vomiting or Diarrhea", 
//             // answer: vomitState ? vomitState : 'No', 
//             options: ["Yes", "No"] },
//           { question: "Fatigue or Lethargy", 
//             // answer: fatigueState ? fatigueState : 'No',
//              options: ["Yes", "No"] },
//         ],
//       },
//     ],
//   },
//   {
//     section: "Nutrition and Eating Habits",
//     questions: [
//       {
//         question: "Does your child have a balanced diet?",
//         // answer: balancedDiet ? balancedDiet : 'Yes',
//         options: ["Yes", "No"],
//       },
//       {
//         question: "How often does your child consume the following?",
//         subquestions: [
//           { question: "Fruits", 
//             // answer: fruitsFrequency ? fruitsFrequency : 'Sometimes',
//              options: ["Daily", "Sometimes", "Rarely"] },
//           { question: "Vegetables", 
//             // answer: vegetablesFrequency ? vegetablesFrequency : 'Sometimes',
//              options: ["Daily", "Sometimes", "Rarely"] },
//           { question: "Meat or Protein", 
//             // answer: meatFrequency ? meatFrequency : 'Sometimes', 
//             options: ["Daily", "Sometimes", "Rarely"] },
//           { question: "Dairy Products", 
//             // answer: dairyFrequency ? dairyFrequency : 'Sometimes',
//              options: ["Daily", "Sometimes", "Rarely"] },
//         ],
//       },
//     ],
//   },
//   {
//     section: "Family Medical History",
//     questions: [
//       {
//         question: "Is there any family history of the following conditions?",
//         subquestions: [
//           { question: "Diabetes", 
//             // answer: familyHistoryDiabetes ? familyHistoryDiabetes : 'No',
//              options: ["Yes", "No"] },
//           { question: "Hypertension", 
//             // answer: familyHistoryHypertension ? familyHistoryHypertension : 'No',
//              options: ["Yes", "No"] },
//           { question: "Asthma", 
//             // answer: familyHistoryAsthma ? familyHistoryAsthma : 'No', 
//             options: ["Yes", "No"] },
//           { question: "Heart Disease",
//             //  answer: familyHistoryHeartDisease ? familyHistoryHeartDisease : 'No', 
//              options: ["Yes", "No"] },
//         ],
//       },
//     ],
//   },
//   {
//     section: "School Performance",
//     questions: [
//       {
//         question: "Does your child attend school regularly?",
//         // answer: schoolAttendance ? schoolAttendance : 'Yes',
//         options: ["Yes", "No"],
//       },
//       {
//         question: "Are there any concerns regarding your child’s school performance?",
//         // answer: schoolPerformance ? schoolPerformance : 'No',
//         options: ["Yes", "No"],
//         // moreinfo: { question: "If yes, please specify", answer: schoolPerformanceConcerns },
//       },
//     ],
//   },
// ];

// useEffect(() => {
//   const pushOptionsToForm = () => {
//     const updatedForm = [];

//     questionnaire.forEach((section) => {
//       section.questions.forEach((question) => {
//         console.log("Processing Question:", question.question);
//         console.log("Options Found:", question.options);

//         if (question.options) {
//           updatedForm.push({
//             question: question.question,
//             subsectionname: section.section,
//             options: question.options,
//           });
//         }

//         if (question.subquestions) {
//           question.subquestions.forEach((subquestion) => {
//             console.log("Processing Subquestion:", subquestion.question);
//             console.log("Options Found:", subquestion.options);

//             if (subquestion.options) {
//               updatedForm.push({
//                 question: subquestion.question,
//                 subsectionname: section.section,
//                 options: subquestion.options,
//               });
//             }
//           });
//         }
//       });
//     });

//     console.log("Updated Form Data:", updatedForm);
//     setPatientVisitFormSection3(updatedForm);
//   };

//   pushOptionsToForm();
// }, []);

// const handleChildAnswerChange = (value, question) => {
//   setChildAnswers((prevAnswers) => {
//     const updatedAnswers = { ...prevAnswers };
//     const sectionKey = patientVisitFormSection3.find(
//       (item) => item.question === question
//     )?.subsectionname;

//     if (!sectionKey) return updatedAnswers;

//     updatedAnswers[sectionKey] = {
//       ...updatedAnswers[sectionKey],
//       [question]: value,
//     };
//     console.log('updatedAnswers: ', updatedAnswers)

//     return updatedAnswers;
//   });

//   // Update the `patientVisitFormSection5` state if needed
//   setPatientVisitFormSection3((prev) => {
//     if (!prev) return prev;

//     return prev.map((item) => {
//       if (item.question === question) {
//         return { ...item, value };
//       }
//       return item;
//     });
//   });
// };
// const handleChildAnswerChange = (value, question) => {
      
//   // Update the `patientVisitFormSection5` state if needed
//   setPatientVisitFormSection3((prev) => {
//     if (!prev) return prev;

//     return prev.map((item) => {
//       if (item.question === question) {
//         return { ...item, value };
//       }
//       return item;
//     });
//   });
// };

// ---------------Child Screening Editable ends ------------------------------------------
  
return (
    <>
    {isLoading && <Loader />}
      <Box
        w="100%"
        display="flex"
        flexWrap="wrap"
        gap="1rem"
        h="100%"
        py={"16px"}
      >
        {/* Demographics */}
        {/* {displayOverview && (
            <GrayCard
              hasFooter={false}
              w={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
              minW={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
              maxW={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
              cardHeader="Demographics"
              cardHeaderIcon="/assets/imgs/measure.png"
              bodyStyle={{ p: "0" }}
              cardBody={
                <>
                  <Flex direction="row" justify="space-around" h="full">
                    <Box
                      p="10px"
                      px="20px"
                      display="flex"
                      flexDir="column"
                      h="100%"
                      justifyContent="center"
                      w="100%"
                    >
                      <Box>
                        <Box
                          as="p"
                          display="inline-block"
                          fontSize="20px"
                          fontWeight="600"
                        >
                          {patienData && patienData.demographics.height ? (
                            <Text fontWeight={"semibold"}>
                              {patienData.demographics.height}
                            </Text>
                          ) : (
                            "0"
                          )}
                        </Box>
                        <Box
                          display="inline-block"
                          as="span"
                          fontSize="12px"
                          fontWeight="400"
                          pl={"5px"}
                        >
                          {patienData && patienData.demographics.heightunit ? (
                            <Text>{patienData.demographics.heightunit}</Text>
                          ) : (
                            "cms"
                          )}
                        </Box>
                      </Box>
                      <Box
                        as="p"
                        fontSize="12px"
                        fontWeight="500"
                        color="#6A707D"
                      >
                        Height
                      </Box>
                    </Box>
  
                    <Box
                      p="10px"
                      px="20px"
                      display="flex"
                      flexDir="column"
                      h="100%"
                      justifyContent="center"
                      w="100%"
                      borderRight="1px solid #E6E7E9"
                      borderLeft="1px solid #E6E7E9"
                      _last={{ borderRight: 0 }}
                    >
                      <Box>
                        <Box
                          as="p"
                          display="inline-block"
                          fontSize="22px"
                          fontWeight="600"
                        >
                          {patienData && patienData.demographics.weight ? (
                            <Text fontWeight={"semibold"}>
                              {patienData.demographics.weight}
                            </Text>
                          ) : (
                            "0"
                          )}
                        </Box>
  
                        <Box
                          display="inline-block"
                          as="p"
                          fontSize="15px"
                          fontWeight="400"
                          pl={"5px"}
                        >
                          {patienData && patienData.demographics.weightunit ? (
                            <Text>{patienData.demographics.weightunit}</Text>
                          ) : (
                            "Kg"
                          )}
                        </Box>
                      </Box>
                      <Box
                        as="p"
                        fontSize="12px"
                        fontWeight="500"
                        color="#6A707D"
                      >
                        Weight
                      </Box>
                    </Box>
  
                    <Box
                      p="10px"
                      px="20px"
                      display="flex"
                      flexDir="column"
                      h="100%"
                      justifyContent="center"
                      w="100%"
                      borderRight="1px solid #E6E7E9"
                      borderLeft="1px solid #E6E7E9"
                      _last={{ borderRight: 0 }}
                    >
                      <Box>
                        <Box
                          as="p"
                          display="inline-block"
                          fontSize="22px"
                          fontWeight="600"
                        >
                          {patienData && patienData.demographics.bmi ? (
                            <Text fontWeight={"semibold"}>
                              {patienData.demographics.bmi}
                            </Text>
                          ) : (
                            "0"
                          )}
                        </Box>
                      </Box>
                      <Box
                        as="p"
                        fontSize="12px"
                        fontWeight="500"
                        color="#6A707D"
                      >
                        BMI
                      </Box>
                    </Box>
                  </Flex>
                </>
              }
            />
          )} */}

        {/* Treatment Team */}
        {/* <GrayCard
            hasFooter={false}
            w={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
            minW={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
            maxW={{base: "100%", md: "100%", xl: "calc(50% - 10px)"}}
            bodyStyle={{ p: "0 20px", overflow: "auto", maxH: "220px" }}
            cardHeader="Treatment Team"
            cardHeaderIcon="/assets/imgs/treatment-plan.png"
            cardBody={
              <>
                <Box>
                  {patienData && patienData?.treatmentteam?.length > 0 ? (
                    patienData.treatmentteam.map((item, index) => (
                      <Box
                        key={index}
                        borderBottom="1px solid #E6E7E9"
                        py="0.875rem"
                        display="flex"
                        flexDir="column"
                        gap="0.5rem"
                      >
                        <Text fontSize="16px" fontWeight="600">
                          {item.doctorname}
                        </Text>
                        <Box
                          as="p"
                          p="0.5rem"
                          bg="#F9FAFB"
                          borderLeft="2px solid #14C585"
                          fontSize="0.875rem"
                          fontWeight="500"
                        >
                          Plan: {item.entitytype}
                        </Box>
                        <Text fontSize="12px" fontWeight="500" color="#384052">
                          {formatDate(item.date)}
                        </Text>
                      </Box>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/treatment-plan.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </Box>
              </>
            }
          /> */}

        {/* Past Medical HIstory */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow: patienData.medicalhistory?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="Medical History"
          onClick={() => onHeaderClickChangeToTab(4)}
          cardHeaderIcon="/assets/imgs/medical-history.png"
          cardFooterText="Add Condition"
          // hasFooter={
          //   patienData && patienData.medicalhistory?.length > 0 ? false : true
          // }
          hasFooter={
            true
          }
          cardFooterClickEvent={onAddMedicalConditionClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                <VStack align="stretch">
                  {patienData && patienData.medicalhistory?.length > 0 ? (
                    patienData.medicalhistory.map((elem, index) => (
                      <Stack
                        key={index}
                        direction="column"
                        align="flex-start"
                        gap="0"
                      >
                        <Box display="flex" alignItems="center" gap="5px">
                          <Circle
                            size="12px"
                            bg="white"
                            border="2px solid gray"
                            borderRadius="full"
                            color="black"
                          />
                          <Text fontSize="16px" fontWeight="600">
                            {elem.condition}
                          </Text>
                        </Box>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          h="auto"
                          gap="5px"
                        >
                          <Center
                            h="35px"
                            ml="5px"
                            borderLeft="1px dotted #CDCFD4"
                          ></Center>
                          <Text fontSize="12px" ml="7px" fontWeight="600">
                            {formatDate(elem.conditionidentifieddate)}
                          </Text>
                        </Box>
                      </Stack>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      {/* <PrimaryButton
                        fontSize="14px"
                        variant="mdBtn"
                        btnIcon="/assets/imgs/add.png"
                        buttonText="Add Condition"
                        onClick={onAddMedicalConditionClick}
                        isDisabled={actionAccessPatients?.create ? false : true}
                      /> */}
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/medical-history.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </VStack>
              </Box>
            </>
          }
        />

        {/* Past Surgical HIstory */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow:
              patienData.surgicalhistory?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="Surgical History"
          cardHeaderIcon="/assets/imgs/surgeries.png"
          onClick={() => onHeaderClickChangeToTab(5)}
          cardFooterText="Add Surgery"
          // hasFooter={
          //   patienData && patienData.surgicalhistory?.length > 0 ? false : true
          // }
          hasFooter={
            true
          }
          cardFooterClickEvent={onAddSurgeryClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                <VStack align="stretch">
                  {patienData && patienData.surgicalhistory?.length > 0 ? (
                    patienData.surgicalhistory.map((surgery, index) => (
                      <Stack
                        key={index}
                        direction="column"
                        align="flex-start"
                        gap="0"
                      >
                        <Box display="flex" alignItems="center" gap="5px">
                          <Circle
                            size="12px"
                            bg="white"
                            border="2px solid gray"
                            borderRadius="full"
                            color="black"
                          />
                          <Text fontSize="16px" fontWeight="600">
                            {surgery.surgeryName}
                          </Text>
                        </Box>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          h="auto"
                          gap="5px"
                        >
                          <Center
                            h="35px"
                            ml="5px"
                            borderLeft="1px dotted #CDCFD4"
                          ></Center>
                          <Text fontSize="12px" ml="7px" fontWeight="600">
                            {formatDate(surgery.date)}
                          </Text>
                        </Box>
                      </Stack>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      {/* <PrimaryButton
                        fontSize="14px"
                        variant="mdBtn"
                        btnIcon="/assets/imgs/add.png"
                        buttonText="Add Surgery"
                        onClick={onAddSurgeryClick}
                        isDisabled={actionAccessPatients?.create ? false : true}
                      /> */}
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/surgeries.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </VStack>
              </Box>
            </>
          }
        />

        {/* Allergy History */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow: patienData.allergy?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="Allergies"
          cardHeaderIcon="/assets/imgs/medical-history.png"
          onClick={() => onHeaderClickChangeToTab(8)}
          cardFooterText="Add Allergy"
          // hasFooter={
          //   patienData && patienData.allergy?.length > 0 ? false : true
          // }
          hasFooter={
            true
          }
          cardFooterClickEvent={onAddAllergyClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                {patienData && patienData.allergy?.length > 0 ? (
                  patienData.allergy.map((allergy, index) => (
                    <Box
                      key={index}
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-around"
                      gap="10px"
                    >
                      <Box>
                        <Text fontSize="16px" fontWeight="600">
                          {allergy.allergyFrom}
                        </Text>
                        <Box
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                        >
                          <Text
                            fontSize="12px"
                            fontWeight="500"
                            color="#384052"
                          >
                            <Box display="flex">
                              <Text
                                fontSize="0.75rem"
                                fontWeight="bold"
                                color="#384052"
                              >
                                Problems:{" "}
                              </Text>
                              <Text
                                fontSize="0.75rem"
                                fontWeight="500"
                                color="#384052"
                              >
                                {allergy?.problems}
                              </Text>
                            </Box>

                            <Text
                              fontSize="0.75rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              Identified:{" "}
                              <Text
                                fontSize="0.75rem"
                                as={"span"}
                                fontWeight="500"
                                color="#384052"
                              >
                                {moment(allergy.allergyidentifieddate).format(
                                  "DD MMM YYYY"
                                )}
                              </Text>
                            </Text>
                          </Text>
                        </Box>
                      </Box>
                      <Divider size="1px" colorScheme="#E6E7E9" />
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    height={"220px"}
                  >
                    {/* <PrimaryButton
                      fontSize="14px"
                      variant="mdBtn"
                      btnIcon="/assets/imgs/add.png"
                      buttonText="Add Allergy"
                      onClick={onAddAllergyClick}
                      isDisabled={actionAccessPatients?.create ? false : true}
                    /> */}
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/medical-history.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
        />

        {/* Social History */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow: patienData.socialhistory?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="social History"
          cardHeaderIcon="/assets/imgs/social-history-bar.png"
          onClick={() => onHeaderClickChangeToTab(7)}
          cardFooterText="Add Social"
          hasFooter={
            patienData && patienData.socialhistory?.length > 0 ? false : true
          }
          cardFooterClickEvent={onAddSocialHistoryClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                {patienData && patienData.socialhistory?.length > 0 ? (
                  patienData.socialhistory.map((history, index) => (
                    <Box
                      key={index}
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-around"
                      gap="10px"
                    >
                      <Box>
                        <Text fontSize="16px" fontWeight="600">
                          {history.type}
                        </Text>
                        <Box
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                        >
                          <Text
                            fontSize="12px"
                            fontWeight="500"
                            color="#384052"
                          >
                            <Box display="flex">
                              <Text
                                fontSize="0.75rem"
                                fontWeight="bold"
                                color="#384052"
                              >
                                Status:{" "}
                              </Text>
                              <Text
                                fontSize="0.75rem"
                                fontWeight="500"
                                color="#384052"
                              >
                                {/* 5 years */}
                                {/* {`${social.fromdate} - ${social.todate}`} */}
                                {/* {`${totalYears} years`} */}
                                {history.iscurrent == 1
                                  ? " Current"
                                  : history.iscurrent == 0
                                    ? " Never"
                                    : history.iscurrent == 2
                                      ? " Former"
                                      : ""}
                              </Text>
                            </Box>
                            {/* {`${calculateYearsDifference(
                                history.fromdate,
                                history.todate
                              )}`}
                              : {history.frequency} x per {history.frequencytype} */}
                            <Text
                              fontSize="0.75rem"
                              fontWeight="500"
                              color="#384052"
                            >
                              {/* 5x per day */}
                              {/* {social.frequency}  {social.frequencytype} */}
                              {history.frequency && history.frequency !== 0
                                ? `${history.frequency} 
                                ${
                                  history.type && history.type == "Smoking"
                                    ? "Packs"
                                    : history.type == "Alcohol"
                                      ? "Drinks"
                                      : history.type == "Smokeless"
                                        ? "Cans"
                                        : history.type == "Illicit Drugs"
                                          ? "Times"
                                          : "Packs"
                                } 
                                Per ${history.frequencytype}   
                                x ${
                                  calculateYearsDifference(
                                    history.fromdate,
                                    history.todate
                                  ) == 1
                                    ? calculateYearsDifference(
                                        history.fromdate,
                                        history.todate
                                      ) + " year"
                                    : calculateYearsDifference(
                                          history.fromdate,
                                          history.todate
                                        ) > 1
                                      ? calculateYearsDifference(
                                          history.fromdate,
                                          history.todate
                                        ) + " years"
                                      : "less than a year"
                                }  
                              `
                                : "-"}
                              {history.iscurrent == 2 && (
                                <>
                                  {` Until ${
                                    history.todate
                                      ? formatDate_yyyy(history.todate)
                                      : ""
                                  }`}
                                </>
                              )}
                            </Text>
                          </Text>
                          {/* {history.frequency > 0 ? (
                              <Image
                                w="13px"
                                h="9px"
                                mx="3px"
                                src="/assets/imgs/red-chart.png"
                              />
                            ) : (
                              <Image
                                w="16px"
                                h="14px"
                                mx="3px"
                                src="/assets/imgs/green-chart.png"
                              />
                            )} */}
                        </Box>
                      </Box>
                      <Divider size="1px" colorScheme="#E6E7E9" />
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    height={"220px"}
                  >
                    {/* <PrimaryButton
                      fontSize="14px"
                      variant="mdBtn"
                      btnIcon="/assets/imgs/add.png"
                      buttonText="Add Social"
                      onClick={onAddSocialHistoryClick}
                      isDisabled={actionAccessPatients?.create ? false : true}
                    /> */}
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/social-history-bar.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
        />

        {/* Past Vaccination HIstory */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow: patienData.vaccinations?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="Vaccination History"
          cardHeaderIcon="/assets/imgs/medical-history.png"
          onClick={() => onHeaderClickChangeToTab(9)}
          cardFooterText="Add Vaccine"
          // hasFooter={
          //   patienData && patienData.vaccinations?.length > 0 ? false : true
          // }
          hasFooter={
            true
          }
          cardFooterClickEvent={onAddVaccineClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                <VStack align="stretch">
                  {patienData && patienData.vaccinations?.length > 0 ? (
                    patienData.vaccinations.map((vaccine, index) => (
                      <Stack
                        key={index}
                        direction="column"
                        align="flex-start"
                        gap="0"
                      >
                        <Box display="flex" alignItems="center" gap="5px">
                          <Circle
                            size="12px"
                            bg="white"
                            border="2px solid gray"
                            borderRadius="full"
                            color="black"
                          />
                          <Text fontSize="16px" fontWeight="600">
                            {vaccine.name}
                          </Text>
                        </Box>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          h="auto"
                          gap="5px"
                        >
                          <Center
                            h="35px"
                            ml="5px"
                            borderLeft="1px dotted #CDCFD4"
                          ></Center>
                          <Text fontSize="12px" ml="7px" fontWeight="600">
                            {formatDate(vaccine.adminDate)}
                          </Text>
                        </Box>
                      </Stack>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      {/* <PrimaryButton
                        fontSize="14px"
                        variant="mdBtn"
                        btnIcon="/assets/imgs/add.png"
                        buttonText="Add Vaccine"
                        onClick={onAddVaccineClick}
                        isDisabled={actionAccessPatients?.create ? false : true}
                      /> */}
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/medical-history.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </VStack>
              </Box>
            </>
          }
        />

        {/* Current medication */}
        {/* {patienData.medicationForOverview?.length > 0 && (
          <GrayCard
            hasFooter={false}
            w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            bodyStyle={{
              p: "2px 2px",
              overflow:
                patienData.medicationForOverview?.length > 0
                  ? "auto"
                  : "hidden",
              maxH: "220px",
            }}
            cardHeader="current medications"
            cardHeaderIcon="/assets/imgs/medication.png"
            onClick={() => onHeaderClickChangeToTab(3)}
            cardBody={
              <>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  gap="50px"
                >
                  <Box>
                    <UnorderedList>
                      {patienData &&
                      patienData.medicationForOverview?.length > 0 ? (
                        patienData.medicationForOverview.map(
                          (medication, index) => (
                            <ListItem
                              key={index}
                              fontSize="14px"
                              fontWeight="600"
                            >
                              {medication.medicinename}
                              {": "}
                              {medication.frequency
                                ? medication.frequency + "-per day"
                                : ""}
                              <Text
                                fontSize="12px"
                                fontWeight="500"
                                color="#384052"
                              >
                                Composition:{" "}
                                {medication.chemicalcomposition
                                  ? medication.chemicalcomposition
                                  : "-/-"}
                              </Text>
                            </ListItem>
                          )
                        )
                      ) : (
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                          alignItems="center"
                          height={"220px"}
                        >
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="26px"
                              opacity="0.5"
                              src="/assets/imgs/treatment-plan.png"
                            />
                          </Box>
                          <Text
                            textAlign="left"
                            fontSize="12px"
                            fontWeight="500"
                          >
                            No Data available
                          </Text>
                        </Box>
                      )}
                    </UnorderedList>
                  </Box>
                </Box>
              </>
            }
          />
        )} */}

        {/* Current medication */}
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{
            p: "10px 20px",
            overflow: patienData.medicationForOverview?.length > 0 ? "auto" : "hidden",
            maxH: "220px",
          }}
          cardHeader="current medications"
          onClick={() => onHeaderClickChangeToTab(3)}
          cardHeaderIcon="/assets/imgs/medication.png"
          cardFooterText="Add Medication"
          // hasFooter={
          //   patienData && patienData.medicationForOverview?.length > 0 ? false : true
          // }
          hasFooter={
            true
          }
          cardFooterClickEvent={onAddMedicationClick}
          isFooterBtnDisabled={actionAccessPatients?.create ? false : true}
          cardBody={
            <>
              <Box>
                <VStack align="stretch">
                  {patienData && patienData.medicationForOverview?.length > 0 ? (
                    patienData.medicationForOverview.map((elem, index) => (
                      <Stack
                        key={index}
                        direction="column"
                        align="flex-start"
                        gap="0"
                      >
                        <Box display="flex" alignItems="center" gap="5px">
                          <Circle
                            size="12px"
                            bg="white"
                            border="2px solid gray"
                            borderRadius="full"
                            color="black"
                          />
                         <Text fontSize="16px" fontWeight="600">
                          {elem.medicinename}:{" "}
                          {elem.frequencytime && elem.frequencyvalue ? (
                            elem.frequencytime === "Hours" ? (
                              `Every ${elem.frequencyvalue} ${elem.frequencytime}`
                            ) : (
                              `${elem.frequencytime} ${
                                elem.frequencyvalue === 1
                                  ? "once"
                                  : elem.frequencyvalue === 2
                                  ? "twice"
                                  : elem.frequencyvalue === 3
                                  ? "thrice"
                                  : `${elem.frequencyvalue} times`
                              }`
                            )
                          ) : (
                            (() => {
                              const times = [];
                              if (elem.morning === 1) times.push("Morning");
                              if (elem.afternoon === 1) times.push("Afternoon");
                              if (elem.night === 1) times.push("Night");
                              return `(${times.join(", ")})`;
                            })()
                          )}
                        </Text>

                        </Box>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          h="auto"
                          gap="5px"
                        >
                          <Center
                            h="35px"
                            ml="5px"
                            borderLeft="1px dotted #CDCFD4"
                          ></Center>
                          <Text fontSize="12px" ml="7px" fontWeight="600">
                            {/* {formatDate(elem.conditionidentifieddate)} */}
                            Composition:{" "}
                                {elem.chemicalcomposition
                                  ? elem.chemicalcomposition
                                  : "-"}
                          </Text>
                        </Box>
                      </Stack>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      {/* <PrimaryButton
                        fontSize="14px"
                        variant="mdBtn"
                        btnIcon="/assets/imgs/add.png"
                        buttonText="Add Condition"
                        onClick={onAddMedicalConditionClick}
                        isDisabled={actionAccessPatients?.create ? false : true}
                      /> */}
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/treatment-plan.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </VStack>
              </Box>
            </>
          }
        />

        {/* Family History */}
        {patienData.familyhistory?.length > 0 && (
          <GrayCard
            hasFooter={false}
            w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            bodyStyle={{
              p: "10px 20px",
              overflow:
                patienData.familyhistory?.length > 0 ? "auto" : "hidden",
              maxH: "220px",
            }}
            cardHeader="Family history"
            cardHeaderIcon="/assets/imgs/family-history.png"
            onClick={() => onHeaderClickChangeToTab(6)}
            cardBody={
              <>
                <Box display="flex" flexDirection="column" gap="10px">
                  {patienData && patienData.familyhistory?.length > 0 ? (
                    patienData.familyhistory.map((family, index) => (
                      <Box
                        key={index}
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Box>
                          <Text fontSize="16px" fontWeight="600">
                            {family.relation}
                          </Text>
                          <Text
                            fontSize="12px"
                            fontWeight="500"
                            color="#384052"
                          >
                            {formatDate(family.dob)}
                          </Text>
                          <Box
                            display="flex"
                            alignItems="center"
                            flexWrap="wrap"
                          >
                            {family.medicalcondition &&
                              family.medicalcondition.map(
                                (condition, index) => (
                                  <Box
                                    as="p"
                                    display="flex"
                                    alignItems="center"
                                    flexDir="row"
                                    fontSize="10px"
                                    key={index}
                                    title={family.medicalcondition
                                      .map((condition) => condition.condition)
                                      .join(", ")}
                                  >
                                    <Box as="span" fontSize="8px" mr="3px">
                                      ●{" "}
                                    </Box>{" "}
                                    {condition.condition}
                                    {index <
                                      family.medicalcondition.length - 1 &&
                                      ", "}
                                  </Box>
                                )
                              )}
                          </Box>
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          border="1px solid #E6E7E966"
                          bg="#E6E7E966"
                          p="4px"
                          px="6px"
                          borderRadius="full"
                        >
                          <Text
                            as="span"
                            color="#384052"
                            fontSize="10px"
                            ml="2px"
                          >
                            {family.isdeceased ? "Deceased" : "Alive"}
                          </Text>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      gap="10px"
                      alignItems="center"
                      height={"220px"}
                    >
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="26px"
                          opacity="0.5"
                          src="/assets/imgs/family-history.png"
                        />
                      </Box>
                      <Text textAlign="left" fontSize="12px" fontWeight="500">
                        No Data available
                      </Text>
                    </Box>
                  )}
                </Box>
              </>
            }
          />
        )}

        {/* Vitals */}
        {patienData?.vitals?.some((vital) => vital.vitalValue !== null) && (
          <Box
            display="flex"
            justifyContent="space-between"
            gap="20px"
            w="100%"
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              <GrayCard
                hasFooter={false}
                bodyStyle={{ p: "0" }}
                cardHeader="vitals"
                cardHeaderIcon="/assets/imgs/heart.png"
                onClick={() => onHeaderClickChangeToTab(2)}
                cardBody={
                  <>
                    <Box width="100%" overflowX="auto">
                      <SimpleGrid minChildWidth="8.75rem">
                        {patienData && patienData.vitals?.length > 0
                          ? patienData.vitals.map((vital, index) => (
                              <Box
                                key={index}
                                borderRight="1px solid #E6E7E9"
                                p={4}
                              >
                                <Text
                                  fontSize="12px"
                                  fontWeight="500"
                                  color="#6A707D"
                                >
                                  {vital.vitalName}
                                </Text>
                                <Text
                                  display="inline-block"
                                  fontSize="22px"
                                  fontWeight="600"
                                >
                                  {vital.vitalValue}
                                </Text>
                                <Text
                                  display="inline-block"
                                  fontSize="15px"
                                  pl={"5px"}
                                  fontWeight="400"
                                >
                                  {vital.vitalUnit}
                                </Text>
                                <Box>
                                  <Text
                                    fontSize="12px"
                                    fontWeight="500"
                                    color="#6A707D"
                                  >
                                    {formatDate(vital.vitalDate)}
                                  </Text>
                                </Box>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  mt="0.5rem"
                                  gap="0.25rem"
                                >
                                  {vital.vitalStatus === "High" ? (
                                    <>
                                      <Image
                                        w="12px"
                                        h="auto"
                                        color="#F04438"
                                        src="/assets/imgs/arrow_upward.png"
                                      />
                                      <Text
                                        as="span"
                                        fontSize="12px"
                                        fontWeight="600"
                                        ml="2px"
                                        color="#F04438"
                                      >
                                        {vital.vitalStatus}
                                      </Text>
                                    </>
                                  ) : vital.vitalStatus === "Normal" ? (
                                    <>
                                      <Image
                                        w="12px"
                                        h="auto"
                                        color="#6A707D"
                                        src="/assets/imgs/check.png"
                                      />
                                      <Text
                                        as="span"
                                        fontSize="12px"
                                        fontWeight="600"
                                        ml="2px"
                                        color="#6A707D"
                                      >
                                        {vital.vitalStatus}
                                      </Text>
                                    </>
                                  ) : vital.vitalStatus === "Ok" ? (
                                    <>
                                      <Image
                                        w="12px"
                                        h="auto"
                                        color="#6A707D"
                                        src="/assets/imgs/check.png"
                                      />
                                      <Text
                                        as="span"
                                        fontSize="12px"
                                        fontWeight="600"
                                        ml="2px"
                                        color="#6A707D"
                                      >
                                        {vital.vitalStatus}
                                      </Text>
                                    </>
                                  ) : vital.vitalStatus === "Low" ? (
                                    <>
                                      <Image
                                        w="12px"
                                        h="auto"
                                        color="#D46F11"
                                        src="/assets/svgs/arrow_upward.svg"
                                      />
                                      <Text
                                        as="span"
                                        fontSize="12px"
                                        fontWeight="600"
                                        ml="2px"
                                        color="#D46F11"
                                      >
                                        {vital.vitalStatus}
                                      </Text>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Box>
                              </Box>
                            ))
                          : "no records found"}
                      </SimpleGrid>
                    </Box>
                  </>
                }
              />
            </Box>
          </Box>
        )}

        {/* Investigations */}
        {patienData?.overviewinvestigations?.length > 0 && (
          <Box
            display="flex"
            justifyContent="space-between"
            gap="20px"
            w="100%"
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              <GrayCard
                hasFooter={false}
                bodyStyle={{ p: "0",maxH:'50vh', overflow:'hidden auto' }}
                cardHeader="Investigations"
                cardHeaderIcon="/assets/imgs/investigation.png"
                onClick={() => onHeaderClickChangeToTab(10)}
                cardBody={
                  <>
                    <Box width="100%" overflowX="auto">
                      <SimpleGrid minChildWidth="8.7rem">
                        {patienData &&
                        patienData?.overviewinvestigations?.length > 0 ? (
                          patienData.overviewinvestigations.map(
                            (investigation, index) => (
                              <Box borderWidth="1px" p={4} key={index}>
                                <Text
                                  fontSize="12px"
                                  fontWeight="500"
                                  color="#6A707D"
                                >
                                  {/* White blood cells */}
                                  {investigation.eventtitle
                                    ? investigation.eventtitle
                                    : "Null"}
                                </Text>
                                <Text
                                  display="inline-block"
                                  fontSize={{ lg: "18px", xl: "22px" }}
                                  fontWeight="600"
                                >
                                  {investigation.actualresultvalue
                                    ? investigation.actualresultvalue
                                    : "-"}
                                </Text>
                                {investigation.resultuom && (
                                  <Text
                                    display="inline-block"
                                    fontSize="15px"
                                    fontWeight="400"
                                  >
                                    (
                                    {investigation.resultuom
                                      ? investigation.resultuom
                                      : ""}
                                    )
                                  </Text>
                                )}
                                <Box
                                  display="flex"
                                  flexDirection="row"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <Text
                                      fontSize="12px"
                                      fontWeight="500"
                                      color="#6A707D"
                                    >
                                      {/* May 15, 2024 */}
                                      {formatDate(investigation.verifieddate)}
                                    </Text>
                                  </Box>
                                  {investigation.status === "low" &&
                                  investigation.trendColor === "red" ? (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      transform="scaleY(-1)"
                                    >
                                      <Image
                                        w="12px"
                                        h="auto"
                                        src="/assets/imgs/red-chart.png"
                                        alt="Normal"
                                      />
                                    </Box>
                                  ) : investigation.status === "high" &&
                                    investigation.trendColor === "red" ? (
                                    <Box display="flex" alignItems="center">
                                      <Image
                                        w="12px"
                                        h="auto"
                                        src="/assets/imgs/red-chart.png"
                                        alt="Normal"
                                      />
                                    </Box>
                                  ) : investigation.status === "low" &&
                                    investigation.trendColor === "green" ? (
                                    <Box display="flex" alignItems="center">
                                      <Image
                                        w="12px"
                                        h="auto"
                                        src="/assets/imgs/green-chart.png"
                                        alt="Normal"
                                      />
                                    </Box>
                                  ) : investigation.status === "high" &&
                                    investigation.trendColor === "green" ? (
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      transform="scaleY(-1)"
                                    >
                                      <Image
                                        w="12px"
                                        h="auto"
                                        src="/assets/imgs/green-chart.png"
                                        alt="Normal"
                                      />
                                    </Box>
                                  ) : null}
                                </Box>
                              </Box>
                            )
                          )
                        ) : (
                          <Flex
                            direction="row"
                            justify="space-around"
                            h="full"
                            w="100%"
                            flexWrap="wrap"
                          >
                            <Text>No Data Available</Text>
                            {/* {dataEntries.map((index) => (
                                <SimpleTable NoDataHeader={index} />
                            ))} */}
                          </Flex>
                        )}
                      </SimpleGrid>
                    </Box>
                  </>
                }
              />
            </Box>
          </Box>
        )}

        {/* Lab and Imaging */}
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap={{ base: "wrap", xl: "nowrap" }}
          gap="20px"
          w="100%"
        >
          {patienData.labs?.length > 0 && (
            <GrayCard
              hasFooter={false}
              w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              bodyStyle={{
                p: "10px 20px",
                overflow: patienData.labs?.length > 0 ? "auto" : "hidden",
                maxH: "220px",
              }}
              cardHeader="labs"
              onClick={() => onHeaderClickChangeToTab(11)}
              cardHeaderIcon="/assets/imgs/biotech.png"
              cardBody={
                <>
                  <Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-around"
                      gap="20px"
                    >
                      {patienData && patienData.labs?.length > 0 ? (
                        patienData.labs.map((lab, index) => (
                          <Box key={index}>
                            <Box
                              mb="3px"
                              display="flex"
                              flexDirection="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Text
                                fontSize="16px"
                                fontWeight="600"
                                color="#061027"
                              >
                                {lab.name}
                              </Text>
                              <Text
                                fontSize="12px"
                                fontWeight="500"
                                color="#384052"
                              >
                                {/* {new Date(lab.verifieddate).toLocaleDateString()} */}
                                {formatDate(lab.date)}
                              </Text>
                            </Box>
                            {/* <Text fontSize="14px" fontWeight="500">
                            {lab.summary}
                          </Text> */}                           
                            <Box w="100%" display='flex' gap='10px'>
                            {lab.attachments.map(
                              (attachment, index) =>
                                lab.documenturl && (
                              <Box
                                as="button"
                                key={index}
                                //onClick={()=>window.open(item.imagepath + item.documents)}
                                w="50%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                  onClick={()=>window.open(attachment.link)}
                                >
                                View Document
                                
                                </Box>
                              </Box>
                              )
                              )}
                              <Box
                                as="button"
                                onClick={()=>OpenLabResultModal(lab)}
        
                                w="50%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                View Result
                                
                                </Box>
                              
                              </Box>
                            </Box>                    
                            <Divider
                              mt="10px"
                              size="1px"
                              colorScheme="#E6E7E9"
                            />
                          </Box>
                        ))
                      ) : (
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                          alignItems="center"
                          height={"220px"}
                        >
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="26px"
                              opacity="0.5"
                              src="/assets/imgs/biotech.png"
                            />
                          </Box>
                          <Text
                            textAlign="left"
                            fontSize="12px"
                            fontWeight="500"
                          >
                            No Data available
                          </Text>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </>
              }
            />
          )}

          {patienData.imaging?.length > 0 && (
            <GrayCard
              hasFooter={false}
              w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
              bodyStyle={{
                p: "10px 20px",
                overflow: patienData.imaging?.length > 0 ? "auto" : "hidden",
                maxH: "220px",
              }}
              cardHeader="IMAGING"
              onClick={() => onHeaderClickChangeToTab(12)}
              cardHeaderIcon="/assets/imgs/hand_bones.png"
              cardBody={
                <>
                  <Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-around"
                      gap="20px"
                    >
                      {patienData && patienData.imaging?.length > 0 ? (
                        patienData.imaging.map((image, index) => (
                          <Box key={index}>
                            <Box
                              mb="3px"
                              display="flex"
                              flexDirection="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Text
                                fontSize="16px"
                                fontWeight="600"
                                color="#061027"
                              >
                                {image.name}
                              </Text>
                              <Text
                                fontSize="12px"
                                fontWeight="500"
                                color="#384052"
                              >
                                {/* {new Date(image.verifieddate).toLocaleDateString()} */}
                                {formatDate(image.date)}
                              </Text>
                            </Box>
                            {/* <Text fontSize="14px" fontWeight="500">
                            {image.summary}
                          </Text> */}

                              <Box w="100%" display='flex' gap='10px'>
                              {image.attachments.map((attachment, index) => (
                              <Box
                                as="button"
                                key={index}
                                //onClick={()=>window.open(item.imagepath + item.documents)}
                                w="50%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                  onClick={()=>window.open(attachment.link)}
                                >
                                View Document
                                
                                </Box>
                              </Box>
                              )
                              )}
                              <Box
                                as="button"
                                onClick={()=>OpenImagingResultModal(image)}
        
                                w="50%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                View Result
                                
                                </Box>
                              
                              </Box>
                            </Box>       
                            <Divider
                              mt="10px"
                              size="1px"
                              colorScheme="#E6E7E9"
                            />
                          </Box>
                        ))
                      ) : (
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                          alignItems="center"
                          height={"220px"}
                        >
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="26px"
                              opacity="0.5"
                              src="/assets/imgs/hand_bones.png"
                            />
                          </Box>
                          <Text
                            textAlign="left"
                            fontSize="12px"
                            fontWeight="500"
                          >
                            No Data available
                          </Text>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </>
              }
            />
          )}
        </Box>

        {/* More Advance Details - Section 2  */}
        {/* {patientVisitFormSection2?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Adult Patient Screening"
            cardHeaderIcon="/assets/imgs/investigation.png"
            cardBody={
              <Box>
                {patientVisitFormSection2 &&
                patientVisitFormSection2.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection2.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>


                      {questions.map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            A:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.value}
                            </Text>
                          </Text>
                        </Box>
                      ))}


                      {index <
                        Object.keys(patientVisitFormSection2).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )} */}

        {patientVisitFormSection2?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Adult Patient Screening"
            cardHeaderIcon="/assets/imgs/expand.png"
            onClick={() => {
              if (visitFormSection2.current) {
                setIsAdultOpen(!isAdultOpen)
                visitFormSection2.current.openModal();
              }
            }}
            cardBody={
              <Box>
                {patientVisitFormSection2 &&
                patientVisitFormSection2.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection2.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text>
                            </Text>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}:{" "}
                                    <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection2).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )}

        {/* More Advance Details - Section 3  */}
        {/* {patientVisitFormSection3?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Child Screening"
            cardHeaderIcon="/assets/imgs/investigation.png"
            cardBody={
              <Box>
                {patientVisitFormSection3 &&
                patientVisitFormSection3.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection3.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>


                      {questions.map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            A:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.value}
                            </Text>
                          </Text>
                        </Box>
                      ))}


                      {index <
                        Object.keys(patientVisitFormSection3).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )} */}

        {patientVisitFormSection3?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", '2xl': "calc(100% - 10px)" }}
            minW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", '2xl': "calc(100% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Child Screening"
            cardHeaderIcon="/assets/imgs/expand.png"
            onClick={() => {
              if (visitFormSection3.current) {
                setIsChildOpen(!isChildOpen)
                visitFormSection3.current.openModal();
              }
            }}
            cardBody={
              <Box>
                {patientVisitFormSection3 &&
                patientVisitFormSection3.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection3.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text>
                            </Text>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}:{" "}
                                    <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection3).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )}

        {/* More Advance Details - Section 4  */}
        {/* {patientVisitFormSection4?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Women's Preventive Health Screening"
            cardHeaderIcon="/assets/imgs/investigation.png"
            cardBody={
              <Box>
                {patientVisitFormSection4 &&
                patientVisitFormSection4.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection4.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>


                      {questions.map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            A:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.value}
                            </Text>
                          </Text>
                        </Box>
                      ))}


                      {index <
                        Object.keys(patientVisitFormSection4).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )} */}
        {patientVisitFormSection4?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Women's Preventive Health Screening"
            cardHeaderIcon="/assets/imgs/expand.png"
            onClick={() => {
              if (visitFormSection4.current) {
                setIsWomenOpen(!isWomenOpen)
                visitFormSection4.current.openModal();
              }
            }}
            cardBody={
              <Box>
                {patientVisitFormSection4 &&
                patientVisitFormSection4.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection4.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              A:{" "}
                              {/* <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text> */}
                              {qna.question === 'LMP (Last Menstrual Period)' && (qna.description !== null || qna.value === 'Known') && (
                                <Text as="span" fontWeight="500">
                                                              {qna.description
                                                                ? `${qna.value}, ${formatDate_Do_MMM_YYYY(qna.description)}`
                                                                : qna.value}
                                                            </Text>
                                                            )}
                                                            {qna.question !== 'LMP (Last Menstrual Period)' && (
                                                            <Text as="span" fontWeight="500">
                                                              {qna.description
                                                                ? `${qna.value}, ${qna.description}`
                                                                : qna.value}
                                                            </Text>
                                                            )}
                            </Text>
                            <Box>
                              {qna.question === 'LMP (Last Menstrual Period)' && (qna.description !== null || qna.value === 'Known') && (
                              <Text as="span" fontWeight="600" fontSize="0.875rem">
                              {qna.description
                                // ? `Expected Delivery Date: ${EDDDate}`
                                ? `Expected Delivery Date: ${EDDDate}`
                                : qna.value}
                              </Text> 
                              )}
                            </Box>
                            </>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}:{" "}
                                    <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection4).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )}

        {/* More Advance Details - Section 5  */}
        {/* {patientVisitFormSection5?.length > 0 && (
        <GrayCard
          w={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          minW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          maxW={{ base: "100%", md: "100%", xl: "calc(50% - 10px)" }}
          bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
          hasFooter={false}
          cardHeader="Lifestyle and Mental Health Screening"
          cardHeaderIcon="/assets/imgs/investigation.png"
          cardBody={
            <Box>
              {patientVisitFormSection5 && patientVisitFormSection5.length > 0 ? (
                Object.entries(
                  patientVisitFormSection5.reduce((acc, item) => {
                    acc[item.subsectionname] = acc[item.subsectionname] || [];
                    acc[item.subsectionname].push(item);
                    return acc;
                  }, {})
                ).map(([heading, questions], index) => (
                  <Box key={index} mb={4}>
                    
                    <Text fontSize="16px" fontWeight="600" mb={2}>
                      {heading}
                    </Text>

                    {questions.map((qna, idx) => (
                      <Box key={idx} mb={3}>
                        <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                          Q: <Text as="span" fontWeight="500">{qna.question}</Text>
                        </Text>
                        <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                          A: <Text as="span" fontWeight="500">{qna.value}</Text>
                        </Text>
                      </Box>
                    ))}

                    {index < Object.keys(patientVisitFormSection5).length - 1 && (
                      <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                    )}
                  </Box>
                ))
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  height="220px"
                >
                  <Box textAlign="center" fontSize="16px" fontWeight="600">
                    <Image
                      w="26px"
                      opacity="0.5"
                      src="/assets/imgs/details.png"
                    />
                  </Box>
                  <Text textAlign="center" fontSize="12px" fontWeight="500">
                    No Data available
                  </Text>
                </Box>
              )}
            </Box>
          }
        />
        )} */}

        {patientVisitFormSection5?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            minW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Lifestyle and Mental Health Screening"
            cardHeaderIcon="/assets/imgs/expand.png"
            onClick={() => {
              if (visitFormSection5.current) {
                setIsOpen(!isOpen)
                visitFormSection5.current.openModal();
              }
            }}
            cardBody={
              <Box>
                {patientVisitFormSection5 &&
                patientVisitFormSection5.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection5.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text>
                            </Text>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}:{" "}
                                    <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection5).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )}

        {patientVisitFormSection6?.length > 0 && (
          <GrayCard
            w={{ base: "100%", md: "100%", '2xl': "calc(100% - 10px)" }}
            minW={{ base: "100%", md: "100%", '2xl': "calc(50% - 10px)" }}
            maxW={{ base: "100%", md: "100%", '2xl': "calc(100% - 10px)" }}
            bodyStyle={{ p: "10px 20px", overflow: "auto", maxH: "220px" }}
            hasFooter={false}
            cardHeader="Infant Screening"
            cardHeaderIcon="/assets/imgs/expand.png"
            onClick={() => {
              if (visitFormSection6.current) {
                setIsInfantOpen(!isInfantOpen)
                visitFormSection6.current.openModal();
              }
            }}
            cardBody={
              <Box>
                {patientVisitFormSection6 &&
                patientVisitFormSection6.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection6.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                              type: q.type,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          {qna.question && (qna.question !== "Pregnancy & Birth History" && qna.question !== "Birth Complications") && (
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>
                          )}

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text>
                            </Text>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              // .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}:{" "}
                                    <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection6).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            }
          />
        )}



        <DynamicModal
          ref={visitFormSection2}
          modalHeader={`Adult Patient Screening`}
          modalWidth={"60vw"}
          modalBody={
            <>
              <Box height={"60vh"} overflow={"auto"}>
                {patientVisitFormSection2 &&
                patientVisitFormSection2.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection2.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              {/* A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text> */}
                            </Text>
                            <RadioGroup colorScheme='green' 
                            value={adultAnswers[qna.subsectionname]?.[qna.question] || qna.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleAdultAnswerChange(value, qna.id)} 
                            // onChange={(value) => handleWomenAnswerChange(value, qna.question)} 
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                          </Flex>
                            </>

                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}{" "}
                                    {/* - {subq.subquestion}:{" "} */}
                                    {/* <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )} */}
                                  </Text>
                                  <RadioGroup colorScheme='green' 
                            value={adultAnswers[subq.subsectionname]?.[subq.question] || subq.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleAdultSubAnswerChange(value, subq.subquestion)}  
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                          </Flex>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection2).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
          modalFooterBtn={
            <>
            <Box w='100%' display="flex" gap="1rem" justifyContent="center">
              <PrimaryButton
                buttonText="Save"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  handleAdultAddQuestions();
                  visitFormSection2.current.closeModal();
                }}
              />
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  visitFormSection2.current.closeModal();
                }}
              />
            </Box>
            </>
          }
        />

        <DynamicModal
          ref={visitFormSection3}
          modalHeader={`Child Screening`}
          modalWidth={"50vw"}
          modalBody={
            <>
              <Box height={"50vh"} overflow={"auto"}>
                {patientVisitFormSection3 &&
                patientVisitFormSection3.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection3.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                              options: q.options,
                              followUp: q.followUp,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              {/* A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text> */}
                            </Text>

                            <RadioGroup colorScheme='green' 
                            value={childAnswers[qna.subsectionname]?.[qna.question] || qna.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleChildAnswerChange(value, qna.id)} 
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>  
                          </Flex>
                          {qna.followUp && qna.value === 'Yes' && (
      <PrimaryInput
        inputPlace={qna.followUp}
        inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
        variant="fullRound"
        // defaultValue={qna.description || ""}
        defaultValue={qna.description ?? ""}
        onChange={(e) => handleChildFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
      />
    )}
                            </>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}{" "}
                                    {/* <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )} */}
                                  </Text>

                                  {subq.followUp ? (
                              <PrimaryInput
                                inputPlace={subq.followUp}
                                inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
                                variant="fullRound"
                                defaultValue={subq.value ?? ""}
                                onChange={(e) => handleChildInputsFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
                              />
                            ) : (

                                  <RadioGroup
                        colorScheme='green'
                        value={childAnswers[subq.subsectionname]?.[subq.question] || subq.value}
                        display='flex'
                        gap='0.5rem'
                        // onChange={(value) => handleChildAnswerChange(value, qna.question)} 
                        onChange={(value) => handleChildSubAnswerChange(value, subq.subquestion)} 
                      >
                        {subq.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                      </RadioGroup>
                            )}

                      {/* {qna.followUp &&  ((qna.subquestion === 'Weight-for-Age (WAZ)') || (qna.subquestion === 'Height-for-Age (HAZ)') || (qna.subquestion === 'Weight-for-Height (WHZ)'))  && (
      <PrimaryInput
        inputPlace={qna.followUp}
        inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '25%' } }}
        variant="fullRound"
        defaultValue={qna.value || ""}
        onChange={(e) => handleChildInputsFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
      />
    )} */}
                                </Flex>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection3).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
          modalFooterBtn={
            <>
            <Box w='100%' display="flex" gap="1rem" justifyContent="center">
              <PrimaryButton
                buttonText="Save"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  handleChildAddQuestions();
                  visitFormSection3.current.closeModal();
                }}
              />
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  visitFormSection3.current.closeModal();
                }}
              />
              </Box>
            </>
          }
        />

        <DynamicModal
          ref={visitFormSection4}
          modalHeader={`Women's Preventive Health Screening`}
          modalWidth={"60vw"}
          modalBody={
            <>
              <Box height={"60vh"} overflow={"auto"}>
                {patientVisitFormSection4 &&
                patientVisitFormSection4.length > 0 ? (
                  Object.entries(
                    patientVisitFormSection4.reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        questions.reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              {/* A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text> */}
                            </Text>
                            <RadioGroup colorScheme='green' 
                            value={womenAnswers[qna.subsectionname]?.[qna.question] || qna.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleWomenAnswerChange(value, qna.id, qna.question)}  
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                          {qna.followUp && (qna.question === 'Gravida: How many total pregnancies have you had?' || qna.question === 'Para: How many pregnancies resulted in the birth of a viable infant?' || qna.question === 'Living: How many children are currently living?' || qna.question === 'Abortions: How many pregnancies ended before 20 weeks of gestation?' || qna.question === 'Delivery: How many pregnancies resulted in deliveries (live births or stillbirths)?')  && (
      <PrimaryInput
        inputPlace={qna.followUp}
        inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '25%' } }}
        variant="fullRound"
        defaultValue={qna.value || ""}
        onChange={(e) => handleWomenInputsFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
      />
    )}

{/* {qna.question === 'LMP (Last Menstrual Period)' && (qna.description !== null || qna.value === 'Known') && (
<Text as="span" fontWeight="600">
{qna.description
  ? `Expected Delivery Date: ${qna.description}`
  : qna.value}
</Text> 
)} */}
                          </Flex>
                          {qna.question === 'LMP (Last Menstrual Period)' && qna.value === 'Known' && (
                        <>
                    <Box borderRadius='10px' mt='0.875rem'w={{base:'100%',md:'50%'}}>
                    <DatePicker
                    disableFutureDates={true}
                    placeholderProp="Date*"
                    leftPos={{ left: "5px" }}
                    datePickerInputStyle={{ borderRadius: "10px" }}
                     onDateChange={(value) => handleChange(qna.subsectionname, qna.question, 'lmpDate', value)}
                    defaultDate={qna.description ? formatDate_DD_MM_YYYY(qna.description) : ""}
                  />
                  
                  </Box>
                  {EDDDate &&
                  // <Text w='50%' textAlign='right'><strong>Expected Delivery Date: </strong>
                  <Text w='50%' mt='0.875rem'><strong>Expected Delivery Date: </strong>
                  {/* {EDDDate} */}

                  <Box borderRadius='10px' mt='0.875rem'w={{base:'100%',md:'100%'}}>

                  <DatePickerEDD
                    // disableFutureDates={true}
                    placeholderProp="Expected Delivery Date*"
                    leftPos={{ left: "5px" }}
                    datePickerInputStyle={{ borderRadius: "10px" }}
                    defaultDate={EDDDate ? EDDDate : undefined}
                    id="EDDDate"
                    onDateChange={setEDDDate}
                    value={EDDDate} 
                  />

                        </Box>
                  </Text>}
                  </>
                )}
                           {/* Render follow-up question if "Yes" is selected and followUp tag exists */}
                           {qna.followUp && (
  (qna.value === 'No' && qna.question === "Do you have regular menstrual periods?") || 
  (qna.value === 'Yes' && qna.question !== "Do you have regular menstrual periods?")
) && (
  <PrimaryInput
    inputPlace={qna.followUp}
    inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
    variant="fullRound"
    defaultValue={qna.description ?? ""}
    onChange={(e) => handleWomenFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
  />
)}
                              
                            </>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            // .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                            qna.subquestions?.map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}{" "}
                                    {/* - {subq.subquestion}:{" "} */}
                                    {/* <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )} */}
                                  </Text>
                                  <RadioGroup colorScheme='green'
                            // value={womenAnswers[subq.subsectionname]?.[subq.subquestion] || subq.value}
                            value={subq.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleWomenSubAnswerChange(value, subq.subquestion)} 
                            // onChange={(value) => handleWomenAnswerChange(value, subq.id)} 
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                          </Flex>
                          {qna.followUp && subq.value === 'Yes' && (
        <PrimaryInput
          inputPlace={qna.followUp}
          inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
          variant="fullRound"
          defaultValue={subq.description ?? ""}
          onChange={(e) =>
            handleWomenSubAnswerFollowUpChange(
              qna.subsectionname,
              subq.subquestion,
              qna.id,
              e.target.value
            )
          }
        />
      )}
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection4).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
          modalFooterBtn={
            <>
            <Box w='100%' display="flex" gap="1rem" justifyContent="center">
            <PrimaryButton
                buttonText="Save"
                variant="grayBtn"
                gap= '1rem'
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  // handleAddQuestions()
                  handleWomenAddQuestions()
                }}
              />
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  visitFormSection4.current.closeModal();
                }}
              />
              </Box>
            </>
          }
        />

        <DynamicModal
          ref={visitFormSection5}
          modalHeader={`Lifestyle and Mental Health Screening`}
          modalWidth={"60vw"}
          modalBody={
            <>
              <Box height={"60vh"} overflow={"auto"}>
                {patientVisitFormSection5 &&
                patientVisitFormSection5.length > 0 ? (
                  Object.entries(
                    (patientVisitFormSection5 || []).reduce((acc, item) => {
                      acc[item.subsectionname] = acc[item.subsectionname] || [];
                      acc[item.subsectionname].push(item);
                      return acc;
                    }, {})
                  ).map(([heading, questions], index) => (
                    <Box key={index} mb={4}>
                      {/* Heading */}
                      <Text fontSize="16px" fontWeight="600" mb={2}>
                        {heading}
                      </Text>

                      {/* Group Questions by their main question */}
                      {Object.values(
                        (questions || []).reduce((acc, q) => {
                          acc[q.question] = acc[q.question] || {
                            ...q,
                            subquestions: [],
                          };
                          if (q.subquestion) {
                            acc[q.question].subquestions.push({
                              subquestion: q.subquestion,
                              value: q.value,
                              description: q.description,
                            });
                          }
                          return acc;
                        }, {})
                      ).map((qna, idx) => (
                        <Box key={idx} mb={3}>
                          {/* Main Question */}
                          <Text
                            fontSize="0.875rem"
                            fontWeight="bold"
                            color="#384052"
                          >
                            Q:{" "}
                            <Text as="span" fontWeight="500">
                              {qna.question}
                            </Text>
                          </Text>

                          {/* If no subquestions, show the answer */}
                          {qna.subquestions.length === 0 ? (
                            <>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              {/* A:{" "}
                              <Text as="span" fontWeight="500">
                                {qna.description
                                  ? `${qna.value}, ${qna.description}`
                                  : qna.value}
                              </Text> */}
                            </Text>
                            <RadioGroup colorScheme='green'
                            value={answers[qna.subsectionname]?.[qna.question] || qna.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleMentalAnswerChange(value, qna.question)} 
                            >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                            </Flex>
                            {/* Render follow-up question if "Yes" is selected and followUp tag exists */}
    {qna.followUp && qna.value === 'Yes' && (
      <PrimaryInput
        inputPlace={qna.followUp}
        inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
        variant="fullRound"
        defaultValue={qna.description ?? ""}
        onChange={(e) => handleFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
      />
    )}
                            </>
                          ) : (
                            /* Handle grouped subquestions */
                            // qna.subquestions.map((subq, subIdx) => (
                            //   <Box key={subIdx} ml={0} mt={2}>
                            //     <Text fontSize="0.875rem" fontWeight="bold" color="#384052">
                            //       - {subq.subquestion}: {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text>
                            //     {/* <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                            //        {subq.description
                            //         ? `${subq.value}, ${subq.description}`
                            //         : subq.value}
                            //     </Text> */}
                            //   </Box>
                            // ))
                            qna.subquestions
                              .filter((subq) => subq.value) // Show only if value is non-null and non-empty
                              .map((subq, subIdx) => (
                                <Box key={subIdx} ml={0} mt={2}>
                                  <Text
                                    fontSize="0.875rem"
                                    fontWeight="bold"
                                    color="#384052"
                                  >
                                    - {subq.subquestion}{" "}
                                    {/* <Text as="span" fontWeight="500">
                                      {subq.value}
                                    </Text>
                                    {subq.description && (
                                      <Text as="span" fontWeight="normal">
                                        , {subq.description}
                                      </Text>
                                    )} */}
                                  </Text>
                                </Box>
                              ))
                          )}
                        </Box>
                      ))}

                      {/* Divider after each heading */}
                      {index <
                        Object.keys(patientVisitFormSection5).length - 1 && (
                        <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
                      )}
                    </Box>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="220px"
                  >
                    <Box textAlign="center" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/details.png"
                      />
                    </Box>
                    <Text textAlign="center" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          }
          modalFooterBtn={
            <>
            <Box w='100%' display="flex" gap="1rem" justifyContent="center">
              <PrimaryButton
                buttonText="Save"
                variant="grayBtn"
                gap= '1rem'
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  handleAddQuestions()
                }}
              />
              <PrimaryButton
                buttonText="Close"
                variant="grayBtn"
                btnStyle={{
                  w: "50%",
                  color: COLORS.PRIMARY_COLOR,
                  h: "2.5rem",
                }}
                onClick={() => {
                  visitFormSection5.current.closeModal();
                }}
              />
              </Box>
            </>
          }
        />

<DynamicModal
  ref={visitFormSection6}
  modalHeader={`Infant Screening`}
  modalWidth={"50vw"}
  modalBody={
    <>
      <Box height={"50vh"} overflow={"auto"}>
        {patientVisitFormSection6 &&
        patientVisitFormSection6.length > 0 ? (
          Object.entries(
            patientVisitFormSection6.reduce((acc, item) => {
              acc[item.subsectionname] = acc[item.subsectionname] || [];
              acc[item.subsectionname].push(item);
              return acc;
            }, {})
          ).map(([heading, questions], index) => (
            <Box key={index} mb={4}>
              {/* Heading */}
              <Text fontSize="16px" fontWeight="600" mb={2}>
                {heading}
              </Text>

              {/* Group Questions by their main question */}
              {Object.values(
                questions.reduce((acc, q) => {
                  acc[q.question] = acc[q.question] || {
                    ...q,
                    subquestions: [],
                  };
                  if (q.subquestion) {
                    acc[q.question].subquestions.push({
                      subquestion: q.subquestion,
                      value: q.value,
                      description: q.description,
                      options: q.options,
                      followUp: q.followUp,
                      type: q.type,
                    });
                  }
                  return acc;
                }, {})
              ).map((qna, idx) => (
                <Box key={idx} mb={3}>
                  {/* Main Question */}
                  {qna.question && (qna.question !== "Pregnancy & Birth History" && qna.question !== "Birth Complications") && (
                    <Text
                      fontSize="0.875rem"
                      fontWeight="bold"
                      color="#384052"
                    >
                      Q:{" "}
                      <Text as="span" fontWeight="500">
                        {qna.question}
                      </Text>
                    </Text>
                  )}

                  {/* If no subquestions, show the answer */}
                  {qna.subquestions.length === 0 ? (
                    <>
                      <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                        <Text
                          fontSize="0.875rem"
                          fontWeight="bold"
                          color="#384052"
                        >
                          {/* A:{" "}
                          <Text as="span" fontWeight="500">
                            {qna.description
                              ? `${qna.value}, ${qna.description}`
                              : qna.value}
                          </Text> */}
                        </Text>

                        {qna.type === "checkbox" ? (
                          <Checkbox
                            colorScheme="green"
                            isChecked={qna.value}
                            onChange={(e) => handleInfantCheckboxChange(e.target.checked, qna.id)}
                          />
                        ) : (
                          <RadioGroup colorScheme='green' 
                            value={infantAnswers[qna.subsectionname]?.[qna.question] || qna.value}
                            display='flex'
                            gap='0.5rem'
                            onChange={(value) => handleInfantAnswerChange(value, qna.id)} 
                          >
                            {qna.options?.map((option, optionIdx) => (
                              <Radio value={option} key={optionIdx}>
                                <Text fontSize="0.875rem">{option}</Text>
                              </Radio>
                            ))}
                          </RadioGroup>
                        )}
                      </Flex>
                      {qna.followUp && qna.value === 'Yes' && (
                        <PrimaryInput
                          inputPlace={qna.followUp}
                          inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
                          variant="fullRound"
                          defaultValue={qna.description ?? ""}
                          onChange={(e) => handleInfantFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
                        />
                      )}
                    </>
                  ) : (
                    qna.subquestions
                      // .filter((subq) => subq.value)
                      .map((subq, subIdx) => (
                        <Box key={subIdx} ml={0} mt={2}>
                          <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: 'flex-start', md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                            <Box display='flex' w='25%' justifyContent='space-between'>
                            <Text
                              fontSize="0.875rem"
                              fontWeight="bold"
                              color="#384052"
                            >
                              - {subq.subquestion}
                            </Text>
                            
                            {qna.type === "checkbox" && (
                          <Checkbox
                            colorScheme="green"
                            // isChecked={subq.value || false}
                            // onChange={(e) => handleInfantSubAnswerChange(e.target.checked, subq.subquestion)}
                            isChecked={subq.value === subq.subquestion} 
                            onChange={(e) => handleInfantSubAnswerChange(e.target.checked, subq.subquestion, qna.subsectionname)}
                          />
                        )}
                            </Box>

                            {/* Show PrimaryInput if "Others" checkbox is checked */}
                        {subq.subquestion === "Others" && subq.value === "Others" && (
                          <PrimaryInput
                            inputPlace={subq.followUp || "Please specify"}
                            inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
                            variant="fullRound"
                            defaultValue={subq.description || ""}
                            onChange={(e) => handleInfantOthersInputsFollowUpChange(qna.subsectionname, subq.subquestion, e.target.value)}
                          />
                        )}

                            {subq.subquestion !== "Others" && subq.followUp ? (
                              <PrimaryInput
                                inputPlace={subq.followUp}
                                inputStyleCss={{ mt: '0.5rem', w: { base: '100%', md: '50%' } }}
                                variant="fullRound"
                                defaultValue={subq.value ?? ""}
                                onChange={(e) => handleInfantInputsFollowUpChange(qna.subsectionname, qna.id, e.target.value)}
                              />
                            ) : (
                              <RadioGroup
                                colorScheme='green'
                                value={infantAnswers[subq.subsectionname]?.[subq.question] || subq.value}
                                display='flex'
                                gap='0.5rem'
                                onChange={(value) => handleInfantSubAnswerChange(value, subq.subquestion)} 
                              >
                                {subq.options?.map((option, optionIdx) => (
                                  <Radio value={option} key={optionIdx}>
                                    <Text fontSize="0.875rem">{option}</Text>
                                  </Radio>
                                ))}
                              </RadioGroup>
                            )}
                          </Flex>
                        </Box>
                      ))
                  )}
                </Box>
              ))}

              {/* Divider after each heading */}
              {index <
                Object.keys(patientVisitFormSection6).length - 1 && (
                <Divider size="1px" colorScheme="#E6E7E9" mt={4} />
              )}
            </Box>
          ))
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="220px"
          >
            <Box textAlign="center" fontSize="16px" fontWeight="600">
              <Image
                w="26px"
                opacity="0.5"
                src="/assets/imgs/details.png"
              />
            </Box>
            <Text textAlign="center" fontSize="12px" fontWeight="500">
              No Data available
            </Text>
          </Box>
        )}
      </Box>
    </>
  }
  modalFooterBtn={
    <>
      <Box w='100%' display="flex" gap="1rem" justifyContent="center">
        <PrimaryButton
          buttonText="Save"
          variant="grayBtn"
          btnStyle={{
            w: "50%",
            color: COLORS.PRIMARY_COLOR,
            h: "2.5rem",
          }}
          onClick={() => {
            handleInfantAddQuestions();
            visitFormSection6.current.closeModal();
          }}
        />
        <PrimaryButton
          buttonText="Close"
          variant="grayBtn"
          btnStyle={{
            w: "50%",
            color: COLORS.PRIMARY_COLOR,
            h: "2.5rem",
          }}
          onClick={() => {
            visitFormSection6.current.closeModal();
          }}
        />
      </Box>
    </>
  }
/>
        <ModalRight
            ref={LabResultsModalRef}
            header="Lab Results"
            bodyStyle={{ p: "24px 32px" }}
            modalWidth="700px"
            body={
              <>
              <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">{LabName}:</Box>
               <Table variant="striped" colorScheme="gray">
                                    <Thead>
                                      <Tr>
                                        <Th>Name</Th>
                                        <Th>Value</Th>
                                        <Th>Range</Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {Labresults && Labresults?.map((result, idx) => (
                                        <Tr key={idx}>
                                          <Td>{result.eventtitle}</Td>
                                          <Td>{result.actualresultvalue} {result.resultuom}</Td>
                                          <Td>{result.lower_bound} - {result.upper_bound}</Td>
                                        </Tr>
                                      ))}
                                    </Tbody>
                                  </Table>            
              </>
            }
            hasFooter={false}           
      />
      <ModalRight
            ref={ImagingResultsModalRef}
            header="Imaging Results"
            //bodyStyle={{ p: "24px 32px" }}
            modalWidth="500px"
            body={
              <>
              <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">{ImagingName}</Box>
              <Divider/>
            <Box bg="#fbfbfc" overflow="hidden auto" h="calc(100% - 80px)">
              <Box overflowY="auto">
                <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">Normal results</Box>
                <Box as="h5" fontSize="16px" pb="20px" fontWeight="300">
                  {ImagingNormalValue ? ImagingNormalValue : "-"}
                </Box>
                <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">Abnormal results</Box>
                <Box as="h5" fontSize="16px" pb="20px" fontWeight="300">
                  {ImagingAbNormalValue ? ImagingAbNormalValue : "-"}
                </Box>
                <Box as="h1" fontSize="18px" pb="20px" fontWeight="600">Report Interpretition</Box>
                <Box as="h5" fontSize="16px" pb="20px" fontWeight="300">
                  {ImagingReportInterpretation ? ImagingReportInterpretation : "-"}
                </Box>
              </Box>
            </Box>
              </>
            }
            hasFooter={false}
      />
      </Box>
    </>
  );
};

export default StartVisitOverview;
